import { ShoppingCartService } from './../../shared/services/shopping-cart.service';
import { Custom } from './../../../modals/createorderautoorder.modal';
import { cloneDeep } from 'lodash';
import { Component, OnInit } from '@angular/core';
import { CartService } from '../../shared/services/cart.service';
import { Observable, of, pipe } from 'rxjs';
import { CartItem } from 'src/app/modals/cart-item';
import { ProductService } from '../../shared/services/product.service';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { Cart1Service } from '../../shared/services/cart1.service';
import { OrderService } from '../../shared/services/order.service';
import { PaymentService } from '../../shared/services/payment.service';
import { UserService } from '../../shared/services/user.service';
import { CouponInfo, UserServiceModal } from 'src/app/modals/userservice.modal';
import * as _ from 'lodash';
import { NotificationService } from '../../shared/services/notification.service';
import { RestApiService } from '../../shared/services/restapi.service';
import { UtilityService } from '../../shared/services/utility.service';
import * as moment from 'moment';
import { ConfigService } from '../../shared/services/config.service';
import { CreateAutoOrder, CreateOrder, CreateOrderAndAutoShip, Item, OrderShippingAddress, Payment, ShippingAddress } from 'src/app/modals/createorderautoorder.modal';
import { ShipAddress } from 'src/app/modals/autoship.modal';
import { OrderCreditCard } from 'src/app/modals/enrollment.model';
import { OrderPipe } from 'ngx-order-pipe';
import { ConfirmDialogComponent } from '../../shared/model/confirm-dialog/confirm-dialog.component';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AddSymbolWithNumberPipe } from '../../shared/pipes/add-symbol-with-number.pipe';
import { ItemsListService } from '../../shared/services/itemsList.service';
import { PersistentService } from '../../shared/services/persistent.service';
import { AccountService } from '../../shared/services/account.service';
import { AllowCvvComponent } from '../../shared/model/allow-cvv/allow-cvv.component';
import { AutoshipConfigurationService } from '../../shared/services/autoshipConfiguration.service';
import { CompanyService } from '../../shared/services/company.service';
import { HostedpaymentDialogComponent } from '../../shared/model/hostedpayment-dialog/hostedpayment-dialog.component';
import { CORPORATESTOREID, DefaultCountry,DefaultShipMethodID, REWARDSTORE, MARKETPLACESTORE, EWALLET_MERCHANT_ID, DefaultRegionID, CVV_REQUIRED_MERCHANT_IDS, MAINSTORE } from 'src/app/constant';
import { StoreConstantsService } from '../../shared/services/store-constants.service';
import { PaymentMethodSelectionDialogComponent } from '../../shared/model/payment-method-selection-dialog/payment-method-selection-dialog.component';
import { BounceBackService, BounceBackCoupon } from '../../shared/services/bounceback.service';
import { BounceBackUtilsService } from '../../shared/services/bounceback-utils.service';
@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss']
})
export class CheckoutComponent implements OnInit {

  public cartItems: Observable<CartItem[]> = of([]);
  public buyProducts: CartItem[] = [];
  public commonData: any;
  removable = true;
  amount: number;
  payments: string[] = ['Create an Account?', 'Flat Rate'];
  paymantWay: string[] = ['Direct Bank Transfer', 'PayPal'];
  OrderQuantityCount: number = 10;
  public AutoOrdersData: any[] = [];
  selectedAutoship: any;
  AutoshipEditFlag: boolean = false;
  createOrderRequest: CreateOrderAndAutoShip;
  userService: UserServiceModal;
  selectedshipmethod: any = 1;
  isStateRestrict: boolean = false;
  isDisabledCreateOrder: boolean = false;
  rewardBalance: number = 0;
  rewardError: string = '';
  UseWalletToPayRemainder: boolean = false;
  showRewardsPoints: boolean = false;
  showCouponCode: boolean = false;
  couponCode: string = '';
  couponError: string = '';
  couponSuccess: string = '';
  appliedCoupon: any = null;
  ewalletBalance: number = 0;
  isShowEwalletBalance: boolean = false;
  selectedPaymentMethod: any = null;
  
  // BounceBack properties
  bounceBackAppliedCoupon: BounceBackCoupon | null = null;
  bounceBackDiscountAmount: number = 0;
  bounceBackLoading: boolean = false;
  showBounceBackRewards: boolean = false;

  
  // LRBASE-based reward points system properties
  maxPointsSpend: number = 0;
  eligiblePointsValue: number = 0;
  lrbaseTotals: number = 0;
  pointsApplied: number = 0;
  canApplyPoints: boolean = false;
  isApplyingPoints: boolean = false;

  constructor(
    public notificationService: NotificationService,
    public user: UserService,
    private titleService: Title,
    public paymentService: PaymentService,
    public translate: TranslateService,
    public cart1Service: Cart1Service,
    public orderService: OrderService,
    private cartService1: CartService,
    public itemsService: ProductService,
    public apiService: RestApiService,
    public utilityService: UtilityService,
    public configService: ConfigService,
    private dialog: MatDialog,
    private router: Router,
    private orderPipe: OrderPipe,
    public itemsListService: ItemsListService,
    public persistentService: PersistentService,
    public accountService: AccountService,
    public autoshipConfigurationService: AutoshipConfigurationService,
    public companyService: CompanyService,
    public shoppingCartService: ShoppingCartService,
    public bouncebackService: BounceBackService,
    public bouncebackUtils: BounceBackUtilsService,
    public storeConstantsService: StoreConstantsService
  ) {
    this.userService = this.user.userServiceModal;
    this.commonData = this.configService.getConfig();
  }

  ngOnInit() {
    // Allow checkout when user is adding more items to autoship (AddMoreItemInAutoshipFlag = true)
    // Only redirect to autoship-edit if editing autoship directly (not adding items via checkout)
    if (this.utilityService.getAutoshipEditFlag() && !this.persistentService.retailData.AddMoreItemInAutoshipFlag) {
      const autoshipId = this.persistentService.retailData.CurrentSelectedAutoOrder;
      if (autoshipId) {
        this.notificationService.warning('Notice', 'Please complete your autoship modification or cancel to proceed with checkout');
        this.router.navigate(['/account/autoships/edit'], {
          queryParams: {
            id: autoshipId,
            ispaid: false
          }
        });
        return;
      }
    }

    // If in "Add More Items" flow, set the selected autoship for update
    if (this.persistentService.retailData.AddMoreItemInAutoshipFlag) {
      this.selectedAutoship = this.persistentService.retailData.CurrentSelectedAutoOrder;
    }
    
    sessionStorage.setItem('IsEnrollment', null);
    this.orderService.getstoreId();
    
    this.clearStaleOrderData();
    
    // Check if user is checking out from rewards store
    const currentStoreId = sessionStorage.getItem('selectedStoreId');
    
    // Wait for store constants to be updated, then set the display flags
    this.storeConstantsService.storeConstants$.subscribe(storeConstants => {
      // Show bounceback functionality only in marketplace store
      this.showBounceBackRewards = currentStoreId === storeConstants.MARKETPLACESTORE;
      
      // Show rewards points and coupon code sections based on store
      this.showRewardsPoints = currentStoreId === storeConstants.REWARDSTORE;
      this.showCouponCode = currentStoreId === storeConstants.MARKETPLACESTORE;
    });
    this.translate.get('global_Company_Title').subscribe((text: string) => {
      this.titleService.setTitle(this.translate.instant('pagetitle_checkout') + ' | ' + text);
    });
    this.cartItems = this.cartService1.getItems();
    this.cartItems.subscribe(products => this.buyProducts = products);
    this.getTotal().subscribe(amount => this.amount = amount);
    
    // Check items after a delay to see if they're loaded later
    setTimeout(() => {
      // Try to populate items service from cart service if empty
      if (this.itemsService.selectedOrderItems.length === 0) {
        const cartOrderItems = JSON.parse(localStorage.getItem('cart.order') || '[]');
        if (cartOrderItems && cartOrderItems.length > 0) {
          this.itemsService.selectedOrderItems = cartOrderItems;
          
          // Also try to populate other item types
          const cartAutoshipItems = JSON.parse(localStorage.getItem('cart.autoship') || '[]');
          if (cartAutoshipItems && cartAutoshipItems.length > 0) {
            this.itemsService.selectedAutoOrderItems = cartAutoshipItems;
          }
          
          const cartPackItems = JSON.parse(localStorage.getItem('cart.pack') || '[]');
          if (cartPackItems && cartPackItems.length > 0) {
            this.itemsService.selectedPacks = cartPackItems;
          }
        }
      }
    }, 1000);
    this.persistentService.retailData.isNewAutoship = this.persistentService.retailData.isNewAutoship || true;
    this.selectedAutoship = this.persistentService.retailData.CurrentSelectedAutoOrder;
    
    // Initialize shipping method if not already set
    this.initializeShippingMethod();
    
    if ((this.itemsService.selectedPacks.length + this.itemsService.selectedOrderItems.length + this.itemsService.selectedAutoOrderItems.length <= 0) && (!this.utilityService.getAutoshipEditFlag())) {
      this.notificationService.error('message_', 'your_order_cart_empty_select_atleast_one_item');
      this.router.navigate(['/products/all']);
    }

    if (this.userService.customerData.DefaultShippingAddress && !this.utilityService.isEmptyObject(this.userService.customerData.DefaultShippingAddress)) {
      this.user.setShippingAddress();
      if (this.utilityService.getAutoshipEditFlag()) {
        this.updateAddressWithAutoshipAddress();
      }
    }
    // Only fetch reward points if coming from rewards store
    if(this.showRewardsPoints && this.userService.customerData.CustomerId){
      this.getCustomerRewardPoints(this.userService.customerData.CustomerId);
      // Calculate LRBASE limits after reward points are fetched
      setTimeout(() => {
        this.calculateLRBASERewardLimits();
      }, 500);
    }

    if (this.userService.isAddressChanged && this.userService.newshippingAddress && this.userService.newshippingAddress.Address && this.userService.newshippingAddress.ZipCode) {
      if (this.utilityService.getAutoshipEditFlag()) {
        if (this.userService.isEditAutoshipAddressChanged) {
          this.userService.newshippingAddress.FullName = this.userService.newshippingAddress.FirstName + ' ' + this.userService.newshippingAddress.LastName;
          this.userService.shippingAddress = cloneDeep(this.userService.newshippingAddress);
        } else {
          this.updateAddressWithAutoshipAddress();
        }
      } else {
        this.userService.newshippingAddress.FullName = this.userService.newshippingAddress.FirstName + ' ' + this.userService.newshippingAddress.LastName;
        this.userService.shippingAddress = cloneDeep(this.userService.newshippingAddress);
      }
    }

    if (this.userService.shippingMethods?.length > 0) {
      this.checkItems().then(() => {
        // Items checked with shipping methods
      });
    } else {
      if (this.itemsService.selectedOrderItems.length) {
        this.checkItems().then(() => {
          this.orderService.calculateOrder().then(() => {
            // Order calculated after checkItems
            // Ensure shipping method is set after order calculation
            this.initializeShippingMethod();
            // Calculate LRBASE limits if in rewards store
            if (this.showRewardsPoints) {
              this.calculateLRBASERewardLimits();
            }
          });
        });
        } else {
          // Clear order calculation data if no order items
          this.orderService.calculateOrderResponse = {};
        }
        if (this.itemsService.selectedAutoOrderItems.length) {
          // Call autoship calculation directly to ensure it runs
          this.orderService.calculateAutoOrder().then(() => {
            // Autoship calculation completed
          });
        }
      }



    if (this.utilityService.getAutoshipEditFlag()) {
      if (this.persistentService.retailData.SelectedAutoshipPayment) {
        const autoshipPayment = this.getPaymentByDisplayText(
          this.persistentService.retailData.SelectedAutoshipPayment.PaymentDisplay,
          this.persistentService.retailData.SelectedAutoshipPayment.PaymentTypeID
        );
        this.userService.paymentMethods = autoshipPayment ? [autoshipPayment] : [];
        if (this.userService.paymentMethods.length > 0) {
          // Map the payment method to ensure all display properties are present
          const paymentMethod = this.userService.paymentMethods[0];
          const mappedPaymentMethod = this.mapPaymentMethodProperties({
            ...paymentMethod,
            CardType: paymentMethod.Name,
            Last4: paymentMethod.Ending,
            ExpireMonth: this.persistentService.retailData.SelectedAutoshipPayment.ExpireMonth,
            ExpireYear: this.persistentService.retailData.SelectedAutoshipPayment.ExpireYear,
            Token: paymentMethod.PaymentMethodID,
            BillingAddress: this.persistentService.retailData.SelectedAutoshipPayment.BillingAddress,
            BillingAddress2: this.persistentService.retailData.SelectedAutoshipPayment.BillingAddress2,
            BillingCity: this.persistentService.retailData.SelectedAutoshipPayment.BillingCity,
            BillingCountry: this.persistentService.retailData.SelectedAutoshipPayment.BillingCountry,
            BillingState: this.persistentService.retailData.SelectedAutoshipPayment.BillingState,
            BillingZip: this.persistentService.retailData.SelectedAutoshipPayment.BillingZip
          });
          
          this.userService.paymentMethods = [mappedPaymentMethod];
        }
      }
      if (this.userService.paymentMethods.length == 0) {
        // Don't call setDefaultPayment here - let loadSavedPaymentMethods handle it
        // this.setDefaultPayment();
      }
      if (this.userService.paymentMethods.length > 0) {
        this.paymentService.selectedPaymentTypeName = this.userService.paymentMethods[0].CardType + ' ' + this.userService.paymentMethods[0].Ending;
      }
      localStorage.setItem('userService', JSON.stringify(this.userService));
    } else {
      // Don't call setDefaultPayment here - let loadSavedPaymentMethods handle it
      // this.setDefaultPayment();
    }
    if (Object.keys(this.userService.customerData).length && this.itemsService.selectedAutoOrderItems.length > 0) {
      this.getAutoOrders();
    }
    this.userService.isPaymentChanged = false;
    
    this.getfrequencyName();
    
    // Remove syncPaymentMethods calls - let loadSavedPaymentMethods handle everything
    // this.syncPaymentMethods();
    
    // Remove force refresh payment methods - let loadSavedPaymentMethods handle everything
    // if (this.userService.paymentMethods.length === 0) {
    //   this.paymentService.getPaymentType().then(() => {
    //     this.syncPaymentMethods();
    //   }).catch(error => {
    //     // Error loading payment types
    //   });
    // }
    
    // Fallback: Ensure autoship calculation runs if it hasn't already
    if (this.itemsService.selectedAutoOrderItems.length > 0) {
      setTimeout(() => {
        if (!this.orderService.calculateAutoOrderResponse || !this.orderService.calculateAutoOrderResponse.SubTotal) {
          this.orderService.calculateAutoOrder().then(() => {
            // Fallback autoship calculation completed
          });
        }
      }, 1000);
    }
    
    // Load saved payment methods for all checkout scenarios
    // This ensures payment methods are properly loaded and mapped regardless of the source
    this.loadSavedPaymentMethods();
  }

  // Load saved payment methods for checkout
  loadSavedPaymentMethods() {
    if (this.userService.customerData.CustomerId) {
      const request = {
        customerId: this.userService.customerData.CustomerId
      };
      
      this.apiService.getCustomerSavedPaymentMethods(request).subscribe(
        (result) => {
          try {
            if (result.Message === "Success" && result.Data && result.Data.length > 0) {
              // Apply saved order from localStorage if available and map properties
              const mappedPaymentMethods = this.applySavedPaymentMethodOrder(result.Data);
              
              // Always ensure payment methods are properly mapped, whether they're already set or not
              if (this.userService.paymentMethods.length === 0) {
                // No payment methods set, prioritize non-e-wallet methods first
                let selectedMethod = mappedPaymentMethods[0];
                
                // Look for a non-e-wallet payment method first
                const nonEwalletMethod = mappedPaymentMethods.find(method => method.MerchantId !== EWALLET_MERCHANT_ID);
                
                if (nonEwalletMethod) {
                  selectedMethod = nonEwalletMethod;
                }
                
                // Ensure all required display properties are present
                const displayMethod = this.mapPaymentMethodProperties(selectedMethod);
                
                this.userService.paymentMethods = [displayMethod];
                this.paymentService.selectedPaymentTypeName = displayMethod.CardType + ' ' + displayMethod.Ending;
                localStorage.setItem('userService', JSON.stringify(this.userService));
              } else {
                // Payment methods are already set (e.g., from autoship edit), but ensure they're properly mapped
                const currentMethod = this.userService.paymentMethods[0];
                const mappedMethod = this.mapPaymentMethodProperties(currentMethod);
                
                // Update the payment method with proper mapping
                this.userService.paymentMethods = [mappedMethod];
                this.paymentService.selectedPaymentTypeName = mappedMethod.CardType + ' ' + mappedMethod.Ending;
                localStorage.setItem('userService', JSON.stringify(this.userService));
              }
              
              // Check if e-wallet is selected and show balance
              if (this.userService.paymentMethods.length > 0 && 
                  this.userService.paymentMethods[0].MerchantId === EWALLET_MERCHANT_ID) {
                this.checkEwalletBalance();
              } else {
                // Hide e-wallet balance for non-e-wallet methods
                this.isShowEwalletBalance = false;
                this.ewalletBalance = 0;
              }
            } else {
              // No saved payment methods, but don't show add payment modal automatically
              // Just set empty payment methods and let user choose when they click "Add Payment Method"
              this.userService.paymentMethods = [];
              this.paymentService.selectedPaymentTypeName = '';
            }
          } catch (ex) {
            console.error('Error loading saved payment methods:', ex);
            // Don't show add payment modal on error, just set empty
            this.userService.paymentMethods = [];
            this.paymentService.selectedPaymentTypeName = '';
          }
        },
        (error) => {
          console.error('Error loading saved payment methods:', error);
          // Don't show add payment modal on error, just set empty
          this.userService.paymentMethods = [];
          this.paymentService.selectedPaymentTypeName = '';
        }
      );
    } else {
      // No customer ID, don't show add payment modal
      this.userService.paymentMethods = [];
      this.paymentService.selectedPaymentTypeName = '';
    }
  }

  // Apply saved payment method order from localStorage
  applySavedPaymentMethodOrder(paymentMethods: any[]) {
    const orderData = localStorage.getItem(`paymentMethodOrder_${this.userService.customerData.CustomerId}`);
    if (orderData) {
      try {
        const savedOrder = JSON.parse(orderData);
        const savedOrderMap = new Map();
        
        // Create a map of saved order
        savedOrder.paymentMethodOrder.forEach((item: any) => {
          savedOrderMap.set(item.paymentMethodId, item.order);
        });
        
        // Sort the payment methods based on saved order
        paymentMethods.sort((a, b) => {
          const orderA = savedOrderMap.get(a.PaymentMethodId) ?? 999;
          const orderB = savedOrderMap.get(b.PaymentMethodId) ?? 999;
          return orderA - orderB;
        });
      } catch (error) {
        console.error('Error applying saved payment method order:', error);
      }
    }
    
    // Map all payment methods to ensure they have required properties
    return paymentMethods.map(pm => this.mapPaymentMethodProperties(pm));
  }

  // Check if e-wallet is selected and show balance
  checkEwalletBalance() {
    if (this.userService.paymentMethods.length > 0 && 
        this.userService.paymentMethods[0].MerchantId === EWALLET_MERCHANT_ID) {
      // Set the flag to show e-wallet balance
      this.isShowEwalletBalance = true;
      
      // Check if this is our placeholder e-wallet option
      const paymentMethod = this.userService.paymentMethods[0];
      
      if (paymentMethod.PaymentMethodId === 'ewallet_option') {
        // This is our placeholder e-wallet option, but we still need to fetch the real balance
        if (this.userService.customerData.CustomerId) {
          this.fetchCustomerBalance(EWALLET_MERCHANT_ID, this.userService.customerData.CustomerId);
        } else {
          this.ewalletBalance = 0;
        }
      } else {
        // This is a real e-wallet payment method, get balance using fetchCustomerBalance
        if (this.userService.customerData.CustomerId) {
          this.fetchCustomerBalance(paymentMethod.MerchantId, this.userService.customerData.CustomerId);
        } else {
          this.ewalletBalance = 0;
        }
      }
    } else {
      // Hide e-wallet balance for non-e-wallet methods
      this.isShowEwalletBalance = false;
      this.ewalletBalance = 0;
    }
  }

  createPaymentObject(totalRewardPointsUsed: number) {
    const paymentMethod = this.userService.paymentMethods[0];
    
    const basePayment = {
      CurrencyCode: this.companyService.selectedCurrency.CurrencyCode,
      MerchantId: paymentMethod.MerchantId,
      OnFileCard: "",
      SavePayment: true,
      SavePaymentMethodId: paymentMethod.Token || paymentMethod.token || paymentMethod.PaymentMethodId || "",
      ...(totalRewardPointsUsed > 0 && {Amount: this.getCorrectedTotal()}),
    };

    // For ewallet payments (MerchantId 11), don't include OrderCreditCard
    if (paymentMethod.MerchantId === EWALLET_MERCHANT_ID) {
      return basePayment;
    }

    // For credit card payments, include OrderCreditCard
    const creditCardPayment = {
      ...basePayment,
      OrderCreditCard: {
        CardToken: paymentMethod.Token || paymentMethod.token || paymentMethod.PaymentMethodId || "",
        NameOnCard: (paymentMethod.billingInfo &&
          paymentMethod.billingInfo.fullName) ||
          (this.userService.shippingAddress.FirstName + ' ' + this.userService.shippingAddress.LastName) ||
          "",
        Last4: paymentMethod.Ending || paymentMethod.Last4 || paymentMethod.CreditCardNumberDisplay,
        CardType: paymentMethod.CardType || paymentMethod.Name || paymentMethod.CreditCardTypeDescription,
        ExpirationMonth: paymentMethod.ExpireMonth || 1,
        ExpirationYear: paymentMethod.ExpireYear,
      } as OrderCreditCard,
    };
    
    return creditCardPayment;
  }

  public updateAddressWithAutoshipAddress() {
    this.userService.shippingAddress.FirstName = this.persistentService.retailData.AutoOrderShippingAddress.FirstName;
    this.userService.shippingAddress.LastName = this.persistentService.retailData.AutoOrderShippingAddress.LastName;
    this.userService.shippingAddress.Street1 = this.persistentService.retailData.AutoOrderShippingAddress.Address;
    this.userService.shippingAddress.Street2 = this.persistentService.retailData.AutoOrderShippingAddress.Address2;
    this.userService.shippingAddress.City = this.persistentService.retailData.AutoOrderShippingAddress.City;
    this.userService.shippingAddress.CountryCode = this.persistentService.retailData.AutoOrderShippingAddress.Country;
    this.userService.shippingAddress.Region = this.persistentService.retailData.AutoOrderShippingAddress.State;
    this.userService.shippingAddress.PostalCode = this.persistentService.retailData.AutoOrderShippingAddress.ZipCode;
  }

  setDefaultPayment() {
    this.paymentService.getPaymentType().then(() => {
        const saveMethods = this.paymentService.PaymentTypeResponse['SaveMethods'];
        if (saveMethods && saveMethods.length > 0) {
            this.addSavePayment(saveMethods[0]);
            localStorage.setItem("userService", JSON.stringify(this.userService));
        }
    }).catch(error => {
        // Error fetching payment types
    });
  }

  getPaymentByDisplayText(text, paymentmethodid) {
    let matchingPayment = null;
    this.paymentService.PaymentTypeResponse['SaveMethods']?.some((method) => {
      try {
        let ending = method.Ending || method.CreditCardNumberDisplay || method.Last4 || method.Name;

        if (ending) {
          ending = ending.replace(/\*/g, '');
        }
        if (paymentmethodid == method.PaymentMethodID) {
          matchingPayment = method;
          return true;
        }
        if (!method.PaymentMethodID && ~text.indexOf(ending)) {
          matchingPayment = method;
          return true;
        }
      } catch (e) {
        return true;
      }
    });
    return matchingPayment;
  }

  public getTotal(): Observable<number> {
    return this.cartService1.getTotalAmount();
  }
  getQuantityModel(type, item): any {
    return this.cart1Service[type == 'pack' ? 'packQuantity' : (type == 'autoship' ? 'autoshipQuantity' : ((item && item?.UsePoints) ? 'orderRewardQuantity' : 'orderQuantity'))];
  }
  // Payment Section
  addSavePayment(paymentData) {
    // Store the selected payment method
    this.selectedPaymentMethod = paymentData;
    
    if (
      !this.utilityService.isEmptyObject(
        this.paymentService.SelectedPaymentTypes,
      ) &&
      this.paymentService.SelectedPaymentTypes.MerchantId !==
      paymentData.MerchantId
    ) {
      this.userService.paymentMethods = [];
      this.userService.isPaymentChanged = true;
    }
    this.paymentService.SelectedPaymentTypes = paymentData;
    
    if (paymentData.MerchantId === EWALLET_MERCHANT_ID) {
      this.paymentService.selectedPaymentTypeName = 'E-Wallet';
    } else {
    this.paymentService.selectedPaymentTypeName =
      this.paymentService.SelectedPaymentTypes.DisplayName;
    }
    
    if (this.paymentService.SelectedPaymentTypes.CanSavePayments) {
      this.paymentService.OldSelectedPaymentType = this.paymentService.SelectedPaymentTypes;
      this.paymentService.getPaymentData(paymentData).then(() => {
        this.paymentService.getPaymentType();
      });
    } else {
      this.paymentService.oldSelectedPaymentTypeName =
        this.paymentService.SelectedPaymentTypes.DisplayName;
      this.paymentService.getPaymentData(paymentData).then(() => {
        this.paymentService.getPaymentType();
      });
    }

             const selectpay = {
      CardType: this.paymentService.SelectedPaymentTypes.CardType,
         Last4: this.paymentService.SelectedPaymentTypes.Ending,
         ExpireMonth: this.paymentService.SelectedPaymentTypes.Expires
        ? moment(this.paymentService.SelectedPaymentTypes.Expires).format('M')
           : 0,
         ExpireYear: this.paymentService.SelectedPaymentTypes.Expires
        ? moment(this.paymentService.SelectedPaymentTypes.Expires).format('YYYY')
           : 0,
         Token: this.paymentService.SelectedPaymentTypes.PaymentMethodId
           ? this.paymentService.SelectedPaymentTypes.PaymentMethodId
           : "",
         MerchantId: this.paymentService.SelectedPaymentTypes.MerchantId,
       };
      this.userService.paymentMethods.push(selectpay);
    localStorage.setItem("userService", JSON.stringify(this.userService));
    
    if(paymentData.MerchantId === EWALLET_MERCHANT_ID || paymentData.CanGetBalance){
      this.isShowEwalletBalance = true;
      this.fetchCustomerBalance(paymentData.MerchantId, this.userService.customerData.CustomerId);
    } else {
      this.isShowEwalletBalance = false;
    }
  }

  getPaymentDescription(payment) {
    if (!payment) {
      return '';
    }
    if (payment.CreditCardTypeDescription === 'Unknown') {
      return payment.CreditCardTypeDescription;
    }
    const type = payment.CreditCardTypeDescription || payment.Name || payment.CardType;
    const numb = payment.CreditCardNumberDisplay || new AddSymbolWithNumberPipe().transform(payment.Ending, '*', 4, 11) ||
      new AddSymbolWithNumberPipe().transform(payment.Last4, '*', 4, 11);
    return type + ' ' + numb;
  }

  removeCardDetail(payment) {
    const messageText = this.translate.instant('confirm_delete_payment_info') + ' ' + this.getPaymentDescription(payment) + '?';
    const dialogRef1 = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: '400px',
      data: {
        title: '',
        message: messageText,
        takeaction: this.translate.instant('Delete'),
        noaction: this.translate.instant('cancel'),
      },
      panelClass: '',
      disableClose: true

    });
    dialogRef1.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        this.deleteCreditCard(payment);
      }
    });
  }

  deleteCreditCard(payment) {
    const DeleteCreditCardRequest = {
      customerId: this.userService.customerData.CustomerId,
      merchantid: payment.MerchantId,
      paymentmethodid: payment.PaymentMethodId
    };
    this.apiService
      .deletePaymentMethod(DeleteCreditCardRequest).subscribe((result) => {
        try {
          if (parseInt(result.Status, 10) === 0) {
            if (this.paymentService.selectedPaymentTypeName == (payment.Name + ' ' + payment.Ending)) {
              this.paymentService.SelectedPaymentTypes = {};
              this.userService.paymentMethods = [];
              this.paymentService.selectedPaymentTypeName = '';
              this.paymentService.selectedPaymentTypeName = this.translate.instant('Add_Payment_Method');
            }
            this.notificationService.success('Success', this.translate.instant('successfully_deleted'));
            this.setDefaultPayment();
          } else {
            this.notificationService.error('Error', (result.Message ? result.Message : this.translate.instant('not_remove')));
          }
        } catch (ex) {
          // Error handling
        }
      }, (error) => {
        this.notificationService.error('Error', this.translate.instant('not_remove'));
      },
        () => {
        });
  }

  getCvv(result) {
    if (result) {
      this.placeOrder(result);
    } else {
      this.isDisabledCreateOrder = false;

    }
  }

  checkPlaceOrder() {
    if (this.user.checkIfUserAuthenticatedOrNot()) {
      const cvvMerchantIds = this.configService.localSettings.Global.CVVRequiredMerchantIds || CVV_REQUIRED_MERCHANT_IDS;
      const showCvv = cvvMerchantIds.split(',').filter((item) => {
        return item && item == this.paymentService.SelectedPaymentTypes.MerchantId;
      }).length;
      if (this.paymentService.SelectedPaymentTypes && Object.keys(this.paymentService.SelectedPaymentTypes).length &&
        this.userService.paymentMethods.length && (!this.isStateRestrict && (Object.keys(this.userService.shippingAddress).length > 0)) && (showCvv)) {
        // SHow Allow CVV Model Popup
        const dialogData = this.dialog.open(AllowCvvComponent, {
          disableClose: true,
          panelClass: 'allowCvvModel-dialog'
        });
        dialogData.afterClosed().subscribe((dialogResult) => {
          if (dialogResult) {
            this.getCvv(dialogResult);
          }
        });
      } else {
        this.placeOrder();
      }
    }
    else {
      // Logout and go to home
      this.accountService.logout();
      this.router.navigate(['/home']);
    }
  }


  placeOrder(dataCvvCode?: any) {
    const userData = JSON.parse(localStorage.getItem("user"));
    
    const placeOrderPromise = new Promise((resolve, reject) => {
      // if (this.itemsService.selectedAutoOrderItems.length > 0 && false) {
      //   this.notificationService.error('error_', 'choose_frequency_sidecart');
      //   this.isDisabledCreateOrder = false;
      //   return;
      // }

      // if (this.userService.newUser && this.itemsService.selectedAutoOrderItems.length == 0) {
      //   this.notificationService.error('error_', 'autoship_required_msg');
      //   this.isDisabledCreateOrder = false;
      //   return;
      // }
             if (this.userService.paymentMethods.length > 0) {
         const paymentMethod = this.userService.paymentMethods[0];
         
         // Check for token in multiple possible property names
         const hasToken = paymentMethod.Token || paymentMethod.token || paymentMethod.PaymentMethodId;
         
         // For e-wallet, we don't need Last4 validation
         if (paymentMethod.MerchantId === EWALLET_MERCHANT_ID || paymentMethod.CardType === 'E-Wallet') {
           // E-wallet validation - only check for token
           if (!hasToken) {
             this.notificationService.error('error_', 'shop_please_add_payment');
             this.isDisabledCreateOrder = false;
             return;
           }
         } else {
           // Credit card validation - check for both token and Ending
           const hasEnding = paymentMethod.Ending || paymentMethod.Last4 || paymentMethod.CreditCardNumberDisplay;
           
           if (!hasToken) {
             this.notificationService.error('error_', 'shop_please_add_payment');
             this.isDisabledCreateOrder = false;
             return;
           }
           if (!hasEnding) {
             this.notificationService.error('error_', 'shop_please_add_payment');
             this.isDisabledCreateOrder = false;
             return;
           }
         }
       } else {
         this.notificationService.error('error_', 'shop_please_add_payment');
         this.isDisabledCreateOrder = false;
         return;
       }

      // Ensure FirstName and LastName are populated if missing
      if (!this.userService.shippingAddress.FirstName && this.userService.customerData?.FirstName) {
        this.userService.shippingAddress.FirstName = this.userService.customerData.FirstName;
      }
      if (!this.userService.shippingAddress.LastName && this.userService.customerData?.LastName) {
        this.userService.shippingAddress.LastName = this.userService.customerData.LastName;
      }
      // Fallback: parse from FullName if still empty
      if ((!this.userService.shippingAddress.FirstName || !this.userService.shippingAddress.LastName) && this.userService.shippingAddress.FullName) {
        const nameParts = this.userService.shippingAddress.FullName.trim().split(' ');
        if (nameParts.length >= 1 && !this.userService.shippingAddress.FirstName) {
          this.userService.shippingAddress.FirstName = nameParts[0];
        }
        if (nameParts.length >= 2 && !this.userService.shippingAddress.LastName) {
          this.userService.shippingAddress.LastName = nameParts.slice(1).join(' ');
        }
      }

      if (this.isStateRestrict || (!Object.keys(this.userService.shippingAddress).length) || (!this.userService.shippingAddress.FirstName || !this.userService.shippingAddress.LastName || !this.userService.shippingAddress.Street1 || !this.userService.shippingAddress.PostalCode)) {
        this.notificationService.error('error_', 'please_add_address');
        this.isDisabledCreateOrder = false;
        return;
      }
      // Allow checkout if user has either order items or autoship items
      if(this.itemsService.selectedOrderItems.length == 0 && this.itemsService.selectedAutoOrderItems.length == 0) {
         this.notificationService.error('error_','your_order_cart_empty_select_atleast_one_item');
         setTimeout(() => {
           // Navigate back to the appropriate store based on current context
           const currentStoreId = sessionStorage.getItem('selectedStoreId');
           if (currentStoreId === MARKETPLACESTORE) {
             this.router.navigate(['/marketplace']);
           } else if (currentStoreId === REWARDSTORE) {
             this.router.navigate(['/rewards']);
           } else {
             this.router.navigate(['/shop']);
           }
         }, 1000);
         return;
      }
      const productdetails: Array<Item> = [];
      _.each(this.itemsService.selectedOrderItems, (item) => {
        productdetails.push({
          ItemId: item.ItemID,
          IsReward: false,
          Quantity: !item.UsePoints ? item.Quantity : item.rewardQuantity
        });
      });

      const autoshipproductdetails: Array<Item> = [];
      _.each(this.itemsService.selectedAutoOrderItems, (item) => {
        if (parseInt(item.Quantity, 10) > 0) {
          autoshipproductdetails.push({
            ItemId: item.ItemID,
            IsReward: false,
            Quantity: item.Quantity
          });
        }
      });
      // Only calculate reward points if coming from rewards store
      const totalRewardPointsUsed:number = this.showRewardsPoints ? this.itemsService.selectedOrderItems.reduce((acc, curr) => {
        const points = this.itemsService.getItemRewardCurrency(curr) * curr.rewardQuantity;
        curr.UsePoints && (acc += points);
        return acc;
      }, 0) : 0;
                          this.createOrderRequest = {
         customerId: userData?.CustomerId || this.userService?.customerData?.CustomerId,
         createOrder: {
           customerType: this.userService?.customerTypeID || this.userService?.customerData?.CustomerType || 2,
           RegionId: this.companyService.getRegionID(this.userService?.selectedCountry) || this.companyService.getRegionID(sessionStorage.getItem('selectedCountry')) || DefaultRegionID,
           ShippingAddress: {
             ShipTo: (this.userService.shippingAddress.FirstName + ' ' + this.userService.shippingAddress.LastName).trim(),
             Line1: this.userService.shippingAddress.Street1 || "",
             Line2: this.userService.shippingAddress.Street2 || "",
             State: this.userService.shippingAddress.Region || "",
             City: this.userService.shippingAddress.City || "",
             Zip: this.userService.shippingAddress.PostalCode || "",
             CountryCode: this.userService.shippingAddress.CountryCode || DefaultCountry,
           } as OrderShippingAddress,
           CountryCode: this.userService.shippingAddress.CountryCode,
           // Attention: "No Attention Needed",
           CouponCodes: [],
           CurrencyCode: this.companyService.selectedCurrency.CurrencyCode,
           // FirstName: this.userService.shippingAddress.FirstName,
           Items: productdetails,
           // LastName: this.userService.shippingAddress.LastName,
           // OrderType: 1,
           // PartyId: 0,
                       Payments: [
              this.createPaymentObject(totalRewardPointsUsed)
            ] as Array<Payment>,
           // Phone: this.userService.shippingAddress.Phone,
           PriceGroup: userData?.CustomerType || this.userService?.customerData?.CustomerType,
           ShipMethodId: this.userService.selectedShippingMethod ||
                        this.orderService.calculateOrderResponse?.ShippingMethods?.[0]?.ShipMethodId ||
                        this.userService.shippingMethods?.[0]?.ShipMethodId ||
                        this.userService.shippingMethods?.[0]?.ShipMethodID ||
                        '1',
           // SpecialInstructions: "No Instruction",
           // FIXED: Use MAINSTORE as final fallback instead of hardcoded '3'
           // This ensures new customers from main store get correct StoreId during checkout
           StoreId: sessionStorage.getItem('selectedStoreId') || (this.user?.userServiceModal?.customerData?.IsCorporate == true ?  CORPORATESTOREID : this.orderService.retailStoreId) || MAINSTORE //this.shoppingCartService.getShoppingCart(1)[0]?.StoreID,
           // Custom: null,
         } as unknown as CreateOrder,
       } as CreateOrderAndAutoShip;
      // Only add reward points payment if coming from rewards store
      if(this.showRewardsPoints && totalRewardPointsUsed > 0) {
        this.createOrderRequest.createOrder.Payments.push(
          {
            "Amount": totalRewardPointsUsed,
            "CurrencyCode": "RWD",
            "MerchantId": EWALLET_MERCHANT_ID,
            "OnFileCard": "",
            "SavePayment": false
          }
        );
      }
      if (autoshipproductdetails.length > 0) {
        // Use the selected shipping method, with fallbacks if not available
        const selectedShipMethodId = this.userService.selectedShippingMethod || 
                                    this.orderService.calculateOrderResponse?.ShippingMethods?.[0]?.ShipMethodId || 
                                     this.userService.shippingMethods?.[0]?.ShipMethodId || 
                                     this.userService.shippingMethods?.[0]?.ShipMethodID || 
                                     DefaultShipMethodID;
        
                 this.createOrderRequest.createAutoOrder = {
           ShipMethodId: selectedShipMethodId,
           Frequency: this.persistentService.retailData.Autoship.FrequencyTypeDescription || 'Monthly',
           Items: autoshipproductdetails,
           MerchantId: this.userService.paymentMethods[0].MerchantId,
           // PaymentMerchantId: this.userService.paymentMethods[0].MerchantId,
           PaymentMethodId: this.userService.paymentMethods[0].Token || this.userService.paymentMethods[0].token || "",
           CurrencyCode: this.companyService.selectedCurrency.CurrencyCode,
          ShipAddress: {
            AddressId: 0,
            FirstName: String(this.userService.shippingAddress.FirstName || '').trim(),
            LastName: String(this.userService.shippingAddress.LastName || '').trim(),
            ShipTo: ((this.userService.shippingAddress.FirstName || '') + ' ' + (this.userService.shippingAddress.LastName || '')).trim() || '',
            Street1: this.userService.shippingAddress.Street1 || '',
            Street2: this.userService.shippingAddress.Street2 || '',
            Street3: this.userService.shippingAddress.Street3 || '',
            Region: this.userService.shippingAddress.Region || '',
            City: this.userService.shippingAddress.City || '',
            PostalCode: this.userService.shippingAddress.PostalCode || '',
            CountryCode: this.userService.shippingAddress.CountryCode || DefaultCountry
          } as ShipAddress,
          ShippingAddress: {
            AddressId: 0,
            FirstName: String(this.userService.shippingAddress.FirstName || '').trim(),
            LastName: String(this.userService.shippingAddress.LastName || '').trim(),
            ShipTo: ((this.userService.shippingAddress.FirstName || '') + ' ' + (this.userService.shippingAddress.LastName || '')).trim() || '',
            Street1: this.userService.shippingAddress.Street1 || '',
            Street2: this.userService.shippingAddress.Street2 || '',
            Street3: this.userService.shippingAddress.Street3 || '',
            Region: this.userService.shippingAddress.Region || '',
            City: this.userService.shippingAddress.City || '',
            PostalCode: this.userService.shippingAddress.PostalCode || '',
            CountryCode: this.userService.shippingAddress.CountryCode || DefaultCountry
          } as ShipAddress,
          StartDate: this.autoshipConfigurationService.autoshipDate,
          Custom:{
            AutoShipId:0
          }  as Custom,
        } as CreateAutoOrder;
 
        if (!this.persistentService.retailData.isNewAutoship) {
          this.createOrderRequest.createAutoOrder.Custom = {
            AutoShipId: this.selectedAutoship || 0
          } as Custom;
        }
      }
      this.UseWalletToPayRemainder && (this.createOrderRequest["UseWalletToPayRemainder"] = true);
       // Only apply reward balance if coming from rewards store
       if(this.showRewardsPoints && this.rewardBalance > 0 && this.createOrderRequest.createOrder){
         this.createOrderRequest.createOrder["UseMyWalletAccount"] = true;
         this.createOrderRequest.createOrder["WalletUsedPoints"] = this.rewardBalance;
       }
       
               // Apply coupon codes (including BounceBack) if coming from marketplace store
        if(this.showCouponCode && this.createOrderRequest.createOrder){
         const couponCodes = [];
         
         // Add existing applied coupon if any
         if(this.appliedCoupon) {
           couponCodes.push(this.appliedCoupon.code);
         }
         
         // Add BounceBack coupon if applied (check both component property and session storage)
         if(this.bounceBackAppliedCoupon && this.bounceBackAppliedCoupon.isValid) {
           couponCodes.push(this.bounceBackAppliedCoupon.code);
         } else {
           // Fallback: check session storage for BounceBack coupon
           try {
             const storedBounceBackCoupon = sessionStorage.getItem('bounceBackAppliedCoupon');
             
             if (storedBounceBackCoupon) {
               const couponData = JSON.parse(storedBounceBackCoupon);
               
               if (couponData && couponData.isValid && couponData.code) {
                 couponCodes.push(couponData.code);
               }
             }
           } catch (error) {
             console.warn('Error parsing stored BounceBack coupon:', error);
           }
         }
         
         // Add any other coupons from user service (excluding BounceBack coupons to prevent duplicates)
         if(this.userService.couponInfo.Allcoupons && this.userService.couponInfo.Allcoupons.length > 0) {
           const nonBounceBackCoupons = this.userService.couponInfo.Allcoupons.filter(
             code => !this.bouncebackService.isBounceBackCoupon(code)
           );
           couponCodes.push(...nonBounceBackCoupons);
         }
         
         // Remove duplicates
         this.createOrderRequest.createOrder.CouponCodes = [...new Set(couponCodes)];
       }
       
       if(this.createOrderRequest.createOrder) {
         this.createOrderRequest.createOrder.PartyId = this.utilityService.getQueryParam('partyid') || localStorage.getItem('partyId') || 0;
       }

       // If in "Add More Items" flow, use updateAutoship API instead of creating new
       if (this.persistentService.retailData.AddMoreItemInAutoshipFlag && this.selectedAutoship) {
         this.updateExistingAutoship(resolve, reject);
         return;
       }

       this.apiService.createCustomerOrderAndAutoship(this.createOrderRequest).subscribe((result) => {
        this.isDisabledCreateOrder = false;
        if (result.ErrorMessage === 'CreateOrder_Failed') {
          const whichCard = result.Index === '0' ? 'First' : 'Second';
          const message = whichCard + ' Card failed with Amount: ' + result.Amount;
          this.notificationService.error('error_', this.translate.instant(message));
          reject(this.translate.instant(message));
          return;
        }

        if (result.ErrorMessage === 'invalid_credit_card') {
          this.notificationService.error('error_', this.translate.instant(result.ErrorMessage));
          reject(this.translate.instant(result.ErrorMessage));
          return;
        }

        // Check for payment/card errors in various response properties
        const errorMessage = result.ErrorMessage || result.ErrorDescription || result.Message;
        if (errorMessage) {
          const errorLower = errorMessage.toLowerCase();
          // Check for common payment decline/failure keywords
          if (errorLower.includes('decline') || errorLower.includes('insufficient') ||
              errorLower.includes('card') && (errorLower.includes('fail') || errorLower.includes('error') || errorLower.includes('invalid'))) {
            // Show specific error for card declines
            this.notificationService.error('error_', errorMessage);
            reject(errorMessage);
            return;
          }
        }

        if (!result.Order?.OrderId && !result?.AutoOrder?.AutoorderId) {
          const finalErrorMessage = result.ErrorMessage || result.ErrorDescription || result.Message || 'Order creation failed';
          this.notificationService.error('error_', this.translate.instant(finalErrorMessage));
          reject(this.translate.instant(finalErrorMessage));
          return;
        }

        result.OrderID = (result?.Order?.OrderID || result?.Order?.OrderId);
        result.AutoOrderId = (result?.AutoOrder?.AutoOrderID || result?.AutoOrder?.AutoorderId);
        if (result.OrderID || (result.AutoOrderId || result.AutoOrderId > 0)) {
          this.userService.newUser = false;
          var autoshipItems: any = [];
          var standardItems: any = [];
          try {
            autoshipItems = JSON.parse(localStorage.getItem('cart.autoship')) || [];
            standardItems = JSON.parse(localStorage.getItem('cart.order')) || [];
          } catch (error) {

          }
          if (result.OrderID && this.createOrderRequest.createOrder?.Items?.length > 0) {
            try {
              var items: any = [];
              this.createOrderRequest.createOrder.Items.forEach(ele => {
                this.itemsService.getProduct(ele.ItemId).subscribe(product => {
                  items.push({
                    "itemId": product.ItemID,
                    "productName": product.ProductName,
                    "sku": product.SKU,
                    "quantity": ele.Quantity,
                    "qv": product.QV,
                    "cv": product.CV,
                    "bonus": product.Bonus,
                    "price": product.Price,
                    "languageCode": product.LanguageCode,
                    "currencyCode": product.CurrencyCode,
                  })
                });
              })
              var data = [{
                "orderId": result.OrderID,
                "customerId": this.user.userServiceModal.customerData.CustomerId,
                "sponsorId": this.user.userServiceModal.customerData.SponsorId,
                "orderDetail": {
                  "items": items,
                  "subTotal": this.orderService.calculateOrderResponse.SubTotal || 0,
                  "totalAmount": this.getCorrectedTotal()
                }
              }]
              var tempData = JSON.stringify(data);
              //window['ZTM'].setStats('Tangerine.fun', "PlaceOrder", tempData);
            } catch (error) {

            }
          }
          if ((result.AutoOrderId || result.AutoOrderId > 0) && this.createOrderRequest.createAutoOrder?.Items?.length > 0) {
            try {
              var items: any = [];
              this.createOrderRequest.createAutoOrder.Items.forEach(ele => {
                autoshipItems.forEach(product => {
                  if (parseInt(product.ItemID) == ele.ItemId) {
                    items.push({
                      "itemId": product.ItemID,
                      "productName": product.ProductName,
                      "sku": product.SKU,
                      "quantity": ele.Quantity,
                      "qv": product.QV,
                      "cv": product.CV,
                      "bonus": product.Bonus,
                      "price": product.Price,
                      "languageCode": product.LanguageCode,
                      "currencyCode": product.CurrencyCode,
                    })
                  }
                });
              })
              var Autodata = [{
                "orderId": result.AutoOrderId,
                "customerId": this.user.userServiceModal.customerData.CustomerId,
                "sponsorId": this.user.userServiceModal.customerData.SponsorId,
                "orderDetail": {
                  "items": items,
                  "subTotal": this.orderService.calculateAutoOrderResponse.SubTotal || 0,
                  "totalAmount": this.orderService.calculateAutoOrderResponse.Total || 0
                }
              }]
              var tempData = JSON.stringify(Autodata);
              //window['ZTM'].setStats('Tangerine.fun', "PlaceOrder", tempData);
            } catch (error) {
            }
          }
          localStorage.setItem('SubmitApplication', JSON.stringify(result));
          
          // BounceBack: Log autoship completion for backend tracking
          if (result.AutoOrder?.AutoOrderId && result.AutoOrder?.Status === 0) {
            this.logAutoshipCompletion(result.AutoOrder);
          }
          
          // BounceBack: Log order completion if bounceback coupon was used
          if (result.Order?.OrderId && this.appliedCoupon) {
            this.logOrderCompletion(result.Order);
          }
          
          if (result.Order?.OrderId) {
            this.apiService.GetCustomerRewardPoints(this.user.userServiceModal.customerData.CustomerId)
            .subscribe((result: any) => {
              const { Data } = result;
              if(typeof Data == "number") {
                this.userService.customerData['rewardPointBalance'] = Data;

              }
            });
            if (result.Order?.Payment?.PaymentUrl) {
              const iframeData = result.Order.Payment?.PaymentUrl
              this.getpaymentMethodIframe(iframeData)
            } else {
              this.router.navigate(["/complete"]);
            }
          } else {
            this.utilityService.setAutoshipEditFlag(false);
            this.persistentService.retailData.isChanged = true;
            this.userService.isAddressChanged = false;
            this.userService.isPaymentChanged = false;
            this.userService.isShipMethodChanged = false;
            this.persistentService.retailData.isNewAutoship = true;
            this.persistentService.retailData.editAutoshipItems = [];
            if (result.Order?.Redirect && result.Order.RedirectUrl && result.Order.RedirectUrl.length > 0) {
              window.location = result.Order.RedirectUrl;
            }
            if (result.AutoOrder?.Redirect && result.AutoOrder.RedirectUrl && result.AutoOrder.RedirectUrl.length > 0) {
              window.location = result.AutoOrder.RedirectUrl;
            }
            this.router.navigate(['/complete']);
          }
        }
        resolve(result);
      }, (error) => {
        this.isDisabledCreateOrder = false;

        // Try to extract specific error message from the error response
        let errorMessage = 'some_error_occur_try_again';

        if (error && error.error) {
          // Check for ErrorDescription, ErrorMessage, or Message in the error response
          const specificError = error.error.ErrorDescription || error.error.ErrorMessage || error.error.Message;

          if (specificError) {
            const errorLower = specificError.toLowerCase();
            // Check for payment-related errors
            if (errorLower.includes('decline') || errorLower.includes('insufficient') ||
                errorLower.includes('payment') && errorLower.includes('fail')) {
              errorMessage = specificError;
            } else if (errorLower.includes('card')) {
              errorMessage = specificError;
            } else {
              // Use the specific error message for any other errors
              errorMessage = specificError;
            }
          }
        }

        this.notificationService.error('error_', this.translate.instant(errorMessage));
        reject(this.translate.instant(errorMessage));
      }, () => { });
    });
    return placeOrderPromise;
  }

  /**
   * Update existing autoship when in "Add More Items" flow
   * Uses PUT api/Orders/UpdateAutoship/{autoshipId} instead of creating new
   */
  updateExistingAutoship(resolve: Function, reject: Function) {
    const autoshipproductdetails: Array<Item> = [];

    _.each(this.itemsService.selectedAutoOrderItems, (item) => {
      if (parseInt(item.Quantity, 10) > 0) {
        autoshipproductdetails.push({
          ItemId: item.ItemID,
          IsReward: false,
          Quantity: item.Quantity
        });
      }
    });

    // Get the first available shipping method ID
    const firstShippingMethodId = this.orderService.calculateOrderResponse?.ShippingMethods?.[0]?.ShipMethodId ||
                                  this.userService.shippingMethods?.[0]?.ShipMethodId ||
                                  this.userService.shippingMethods?.[0]?.ShipMethodID ||
                                  DefaultShipMethodID;

    let paymentMethodId = '';
    let merchantId: any = '';

    if (this.userService.paymentMethods.length > 0) {
      const paymentMethod = this.userService.paymentMethods[0];
      merchantId = paymentMethod.MerchantId || this.paymentService.SelectedPaymentTypes?.MerchantId || '';

      const merchantIdNum = typeof merchantId === 'string' ? parseInt(merchantId, 10) : merchantId;

      // For e-wallet, use the MerchantId as PaymentMethodId
      if (merchantIdNum === EWALLET_MERCHANT_ID) {
        paymentMethodId = merchantId.toString();
      } else {
        paymentMethodId = paymentMethod.Token || paymentMethod.PaymentMethodId || this.paymentService.SelectedPaymentTypes?.PaymentMethodId || '';
      }
    }

    const firstName = String(this.userService.shippingAddress.FirstName || '').trim();
    const lastName = String(this.userService.shippingAddress.LastName || '').trim();
    const shipToName = (firstName + ' ' + lastName).trim() || '';

    const updateAutoOrderRequest = {
      ShipMethodId: firstShippingMethodId,
      Frequency: this.persistentService.retailData.Autoship?.FrequencyTypeID?.toString() || '1',
      Items: autoshipproductdetails,
      MerchantId: merchantId,
      PaymentMethodId: paymentMethodId,
      ShippingAddress: {
        AddressId: 0,
        FirstName: firstName,
        LastName: lastName,
        ShipTo: shipToName,
        Street1: this.userService.shippingAddress.Street1 || '',
        Street2: this.userService.shippingAddress.Street2 || '',
        Street3: this.userService.shippingAddress.Street3 || '',
        Region: this.userService.shippingAddress.Region || '',
        City: this.userService.shippingAddress.City || '',
        PostalCode: this.userService.shippingAddress.PostalCode || '',
        CountryCode: this.userService.shippingAddress.CountryCode || DefaultCountry
      } as ShipAddress,
      StartDate: this.autoshipConfigurationService.autoshipDate,
    } as CreateAutoOrder;

    this.apiService.updateAutoship(this.selectedAutoship, updateAutoOrderRequest).subscribe((result) => {
      this.isDisabledCreateOrder = false;

      if (result.Status === 0) {
        // Clear flags and data
        this.utilityService.setAutoshipEditFlag(false);
        this.persistentService.retailData.AddMoreItemInAutoshipFlag = false;
        this.persistentService.retailData.AddMoreItemInAutoshipData = {};
        this.persistentService.retailData.isChanged = false;
        this.persistentService.retailData.CurrentSelectedAutoOrder = 0;
        this.userService.isAddressChanged = false;
        this.userService.isPaymentChanged = false;
        this.userService.isShipMethodChanged = false;
        this.persistentService.retailData.isNewAutoship = false;
        this.persistentService.retailData.editAutoshipItems = [];
        this.persistentService.setRetailData();

        // Clear cart
        this.itemsService.selectedAutoOrderItems = [];
        localStorage.setItem('cart.autoship', JSON.stringify([]));

        this.notificationService.success('Success', 'Autoship updated successfully');

        if (result.RedirectUrl && result.RedirectUrl.length > 0) {
          window.location = result.RedirectUrl;
        } else {
          this.router.navigate(['/account/autoship']);
        }
        resolve(result);
      } else {
        const errorMessage = result.ErrorMessage || result.Message || 'Failed to update autoship';
        this.notificationService.error('error_', this.translate.instant(errorMessage));
        reject(errorMessage);
      }
    }, (error) => {
      this.isDisabledCreateOrder = false;
      let errorMessage = 'some_error_occur_try_again';

      if (error && error.error) {
        const specificError = error.error.ErrorDescription || error.error.ErrorMessage || error.error.Message;
        if (specificError) {
          errorMessage = specificError;
        }
      }

      this.notificationService.error('error_', this.translate.instant(errorMessage));
      reject(errorMessage);
    });
  }

  showBirthWarnings() {
    const orderItem = this.itemsService.selectedOrderItems.some((item) => {
      return item.FlagCancer || item.FlagBirthDefects;
    });
    const autoshipItem = this.itemsService.selectedAutoOrderItems.some((item) => {
      return item.FlagCancer || item.FlagBirthDefects;
    });
    if ((orderItem || autoshipItem) && this.configService.localSettings.Global.ShowBirthWarning) {
      return true;
    } else {
      return false;
    }
  }
  showCancerWarnings() {
    const orderItem = this.itemsService.selectedOrderItems.some((item) => {
      return item.FlagCancer || item.FlagBirthDefects;
    });
    const autoshipItem = this.itemsService.selectedAutoOrderItems.some((item) => {
      return item.FlagCancer || item.FlagBirthDefects;
    });
    if ((orderItem || autoshipItem) && this.configService.localSettings.Global.ShowCancerWarning) {
      return true;
    } else {
      return false;
    }

  }

  checkQuantity(type, item) {
    const quantity = this.getQuantityModel(type, item)[item.ItemID];
    if (!Number(quantity)) {
      this.cart1Service.removeFromCart(item, type == 'autoship', type == 'pack', true);
    } else {
      if (!item.UsePoints) {
        item.Quantity = quantity;
      }
      else if (item.UsePoints) {
        item.rewardQuantity = quantity;
      }
      if (type == 'autoship') {
        localStorage.setItem('cart.autoship', JSON.stringify(this.itemsService.selectedAutoOrderItems));
        this.orderService.calculateAutoOrder();
      } else {
        localStorage.setItem((type == 'pack' ? 'cart.packs' : 'cart.order'),
          JSON.stringify(type == 'pack' ? this.itemsService.selectedPacks : this.itemsService.selectedOrderItems));
        this.orderService.calculateOrder().then(() => {
          // Recalculate LRBASE limits if in rewards store and order items changed
          if (this.showRewardsPoints && type !== 'autoship') {
            this.calculateLRBASERewardLimits();
            // Clear input if validation fails
            if (this.rewardBalance > this.maxPointsSpend) {
              this.rewardBalance = 0;
              this.pointsApplied = 0;
            }
            this.validateLRBASERewardAmount();
          }
        });
      }
    }
    if (!this.utilityService.getAutoshipEditFlag()) {
    }
  }

  /**
   * Wrapper method for increasing quantity that also updates LRBASE limits
   */
  increaseQuantity(type: string, item: any) {
    this.cart1Service.increaseQuantiy(item, type === 'autoship', type === 'pack');
    
    // For order items, recalculate LRBASE limits after a delay
    if (type !== 'autoship' && this.showRewardsPoints) {
      setTimeout(() => {
        this.orderService.calculateOrder().then(() => {
          this.calculateLRBASERewardLimits();
          this.validateLRBASERewardAmount();
        });
      }, 100);
    }
  }

  /**
   * Wrapper method for decreasing quantity that also updates LRBASE limits
   */
  decreaseQuantity(type: string, item: any) {
    this.cart1Service.decreaseQuantiy(item, type === 'autoship', type === 'pack');
    
    // For order items, recalculate LRBASE limits after a delay
    if (type !== 'autoship' && this.showRewardsPoints) {
      setTimeout(() => {
        this.orderService.calculateOrder().then(() => {
          this.calculateLRBASERewardLimits();
          this.validateLRBASERewardAmount();
        });
      }, 100);
    }
  }
  getAutoOrders() {
    this.apiService.getCustomerAutoships(this.userService.customerData.CustomerId).subscribe((result: any) => {
      try {
        if (Number(result.Status) === 0) {
          if (result.Data && result.Data.length > 0) {
            var data = result.Data.filter(item => { return parseInt(item.AutoShipType) != 2 });
            this.AutoOrdersData = this.orderPipe.transform(data, 'AutoShipID', true);
            // Show selected Autoship in dropdown
            this.selectedAutoship = this.persistentService.retailData.CurrentSelectedAutoOrder || this.AutoOrdersData[0].AutoShipID;
            
            // Set AutoOrderShippingAddress from the selected autoship's shipping address
            this.updateAutoOrderShippingAddress();
          }
        }
              } catch (ex) {
          // Error handling
        }
    }, (error) => {
      this.AutoOrdersData = [];
    }, () => { });
  }

  changeSelectedAutosipId(id: any) {
    this.selectedAutoship = id;
    // Update AutoOrderShippingAddress when autoship selection changes
    this.updateAutoOrderShippingAddress();
  }

  updateAutoOrderShippingAddress() {
    if (this.selectedAutoship && this.AutoOrdersData && this.AutoOrdersData.length > 0) {
      // Find the selected autoship data
      const selectedAutoshipData = this.AutoOrdersData.find(autoship => autoship.AutoShipID === this.selectedAutoship);
      
      if (selectedAutoshipData && selectedAutoshipData.ShipAddress) {
        // Set the AutoOrderShippingAddress from the selected autoship's shipping address
        this.persistentService.retailData.AutoOrderShippingAddress = {
          FirstName: selectedAutoshipData.ShipAddress.FirstName || '',
          LastName: selectedAutoshipData.ShipAddress.LastName || '',
          Address: selectedAutoshipData.ShipAddress.Street1 || '',
          Address2: selectedAutoshipData.ShipAddress.Street2 || '',
          City: selectedAutoshipData.ShipAddress.City || '',
          State: selectedAutoshipData.ShipAddress.Region || '',
          Country: selectedAutoshipData.ShipAddress.CountryCode || '',
          ZipCode: selectedAutoshipData.ShipAddress.PostalCode || ''
        };
      }
      this.updateAddressWithAutoshipAddress();
    }
  }

  backStep() {
    // Get the current store ID from sessionStorage
    const currentStoreId = sessionStorage.getItem('selectedStoreId');
    
    // Navigate to the appropriate store based on the current store context
    if (currentStoreId === MARKETPLACESTORE) {
      // If user came from marketplace store, go back to marketplace
      this.router.navigate(['/marketplace']);
    } else if (currentStoreId === REWARDSTORE) {
      // If user came from rewards store, go back to rewards
      this.router.navigate(['/rewards']);
    } else {
      // Default to main store (MAINSTORE or any other store)
      this.router.navigate(['/shop']);
    }
  }

  isAutoshipChanged() {
    if (!moment(this.autoshipConfigurationService.autoshipDate).isSame(this.autoshipConfigurationService.autoshipDate, 'day')) {
      return true;
    }
    if (this.persistentService.retailData.Autoship && this.commonData.FrequencyTypes[0].ID != this.persistentService.retailData.Autoship.FrequencyTypeID) {
      return true;
    }
    if (this.userService.isAddressChanged || this.userService.isPaymentChanged || this.userService.isShipMethodChanged) {
      return true;
    }

    if (this.utilityService.getAutoshipEditFlag()) {
      if (this.persistentService.retailData.isChanged) {
        if (_.isEqual(this.persistentService.retailData.editAutoshipItems, this.itemsService.selectedAutoOrderItems) && this.itemsService.selectedOrderItems.length == 0) {
          return false;
        }
        return true;
      }
      return false;
    }
    return true;
  }

  validatePromoCode() {
    if (this.userService.couponInfo.promoCode) {
      if (this.userService.couponInfo.availableRewards.length > 0) {
        _.each(this.userService.couponInfo.availableRewards, (avlreward) => {
          if (avlreward.Code.toLowerCase() == this.userService.couponInfo.promoCode.toLowerCase()) {
            this.userService.couponInfo.RewardsForUse.push(avlreward);
          }
        });
      }
    }
    this.userService.couponInfo.IsAppliedcode = true;
    this.orderService.calculateOrder().then((result: any) => {
      if (result && this.userService.couponInfo.promoCode) {
        _.each(this.orderService.calculateOrderResponse.CouponResults, (item) => {
          const isInCart = this.userService.couponInfo.Allcoupons.some((code) => {
            if (code.toLowerCase() == item.Code.toLowerCase()) {
              return true;
            }
            return false;
          });

          if (item.IsValid) {
            if (!isInCart) {
              this.userService.couponInfo.Allcoupons.push(item.Code);
            }
            if (this.userService.couponInfo.promoCode == item.Code) {
              this.notificationService.success('success', 'coupon_added_success');
            }
            this.userService.couponInfo.promoCodeValid = true;
            this.userService.couponInfo.promoCode = '';
          } else {
            this.userService.couponInfo.promoCodeValid = false;
            this.userService.couponInfo.IsAppliedcode = false;
            this.userService.couponInfo.promoCode = '';
            if (isInCart && this.itemsService.selectedOrderItems.length) {
              this.userService.couponInfo.Allcoupons = this.userService.couponInfo.Allcoupons.filter((code) => {
                return code.toLowerCase() != item.Code.toLowerCase();
              });
              this.userService.couponInfo.RewardsForUse = this.userService.couponInfo.RewardsForUse.filter((e) => {
                return e.Code.toLowerCase() != item.Code.toLowerCase();
              });
            }
          }
        });
      }
    });
  }

  promoShowHide() {
    let isExitCoupon = [];
    if (this.orderService.calculateOrderResponse.CouponResults != null) {
      isExitCoupon = this.orderService.calculateOrderResponse.CouponResults.filter((Coupon: any) => {
        if (Coupon.Code === 'NewCustomerPromo_' + this.userService.customerData.BackOfficeId) {
          return Coupon.Code;
        } else if (Coupon.IsValid && (Coupon.Code === this.userService.DynamicCouponCode.promoCode)) {
          return Coupon.Code;
        }
      });
    }
    if (isExitCoupon.length > 0) {
      return false;
    } else {
      return true;
    }
  }

  removePromo(code) {
    this.userService.couponInfo.RewardsForUse = _.reject(this.userService.couponInfo.RewardsForUse, (e) => {
      return e.Code.toLowerCase() == code.toLowerCase();
    });
    this.userService.couponInfo.promoCode = '';
    this.userService.couponInfo.promoCodeValid = true;
    this.userService.couponInfo.IsAppliedcode = false;
    this.userService.couponInfo.Allcoupons = _.without(this.userService.couponInfo.Allcoupons, code);
    this.orderService.calculateOrder();
  }

  isCouponCode(Coupon) {
    const NewCustomerPromo = 'NewCustomerPromo_' + this.userService.customerData.BackOfficeId;
    if (Coupon.Code === NewCustomerPromo) {
      return false;
    } else if (Coupon.Code === this.userService.DynamicCouponCode.promoCode) {
      return false;
    } else {
      return true;
    }
  }

  updateShipmethod(shipmethodID) {
    this.userService.selectedShippingMethod = shipmethodID;
    if (this.itemsService.selectedOrderItems.length > 0) {
      this.orderService.calculateOrder();
    }
    if (this.itemsService.selectedAutoOrderItems.length) {
      this.orderService.calculateAutoOrder();
    }
  }

  getAvailableShippingMethods() {
    if (!this.orderService.calculateOrderResponse?.ShippingMethods) {
      return [];
    }
    return this.orderService.calculateOrderResponse.ShippingMethods.filter(
      (shipmethod: any) => shipmethod.ShipMethodId !== 16
    );
  }

  checkItems() {
    const promise = new Promise((resolve, reject) => {
      if (this.userService.checkItems) {
        this.itemsListService.checkRestrictedState('', '', true, true, 0, false, '', true, false).then(() => {
          if (this.userService.shippingAddress.Region) {
            _.each(this.userService.restrictedStates, (state) => {
              if ((state).toLowerCase() === (this.userService.shippingAddress.Region).toLowerCase()) {
                this.isStateRestrict = true;
              }
            });
          }
          resolve(true);
        });
      } else {
        if (this.userService.shippingAddress.Region) {
          _.each(this.userService.restrictedStates, (state) => {
            if ((state).toLowerCase() === (this.userService.shippingAddress.Region).toLowerCase()) {
              this.isStateRestrict = true;
            }
          });
        }
        if (this.itemsService.selectedOrderItems.length) {
          this.orderService.calculateOrder();
        }
        if (this.itemsService.selectedAutoOrderItems.length) {
          this.orderService.calculateAutoOrder();
        }
      }
    });
    return promise;
  }

  getfrequencyName() {
    return { frequency: this.persistentService.retailData.Autoship.FrequencyTypeDescription };
  }

  getpaymentMethodIframe(data: any) {
    const dialogRef = this.dialog.open(HostedpaymentDialogComponent, {
      panelClass: "hosted_payment-Dialog",
      data: {
        Width: data.Width,
        Height: data.Height,
        IFrameUrl: data,
        isCheckout: true
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.setDefaultPayment();
        this.router.navigate(["/complete"]);
      }
    });
  }
  preventNegativeInput(event: KeyboardEvent) {
    if (event.key === '-' || event.key === 'Minus') {
      event.preventDefault();
    }
  }
  validateRewardAmount() {
    const availableBalance = this.userService.customerData['rewardPointBalance'] || 1;
    if (this.rewardBalance > availableBalance && this.rewardBalance > this.orderService.calculateOrderResponse.SubTotal) {
      this.rewardError = "Reward amount cannot be greater than available balance and cannot exceed order subtotal.";
      this.rewardBalance = 0;
    } 
    else if (this.rewardBalance > availableBalance) {
      this.rewardError = "Reward amount cannot be greater than available balance.";
      this.rewardBalance = 0;
    }
    else if (this.rewardBalance > this.orderService.calculateOrderResponse.SubTotal) {
      this.rewardError = "Reward amount cannot exceed order subtotal.";
      this.rewardBalance = 0;
    } 
    else {
      this.rewardError = '';
    }
  }

  /**
   * Calculate LRBASE-based reward points limits for the current order
   */
  calculateLRBASERewardLimits(): void {
    if (!this.showRewardsPoints || !this.itemsService.selectedOrderItems.length) {
      this.maxPointsSpend = 0;
      this.eligiblePointsValue = 0;
      this.lrbaseTotals = 0;
      return;
    }

    // Calculate EPV (Eligible Points Value) = sum of (productPrice - LRBASE) × quantity across all products
    this.eligiblePointsValue = this.itemsService.selectedOrderItems.reduce((acc, item) => {
      const itemPrice = item.Price || 0;
      const itemLRBASE = item.LRBASE || 0;
      const quantity = item.Quantity || 1;
      
      // Line max points = (productPrice - LRBASE) × quantity
      const lineMaxPoints = Math.max(0, (itemPrice - itemLRBASE)) * quantity;
      return acc + lineMaxPoints;
    }, 0);

    // Calculate LRBASE totals = sum of LRBASE × quantity across all products
    this.lrbaseTotals = this.itemsService.selectedOrderItems.reduce((acc, item) => {
      const itemLRBASE = item.LRBASE || 0;
      const quantity = item.Quantity || 1;
      return acc + (itemLRBASE * quantity);
    }, 0);

    // MPS (Max Points Spend) = min(EPV, availablePointsValue)
    const availablePointsValue = (this.userService.customerData['rewardPointBalance'] || 0);
    this.maxPointsSpend = Math.min(this.eligiblePointsValue, availablePointsValue);

    // Don't automatically correct user input - let validation handle it
    // if (this.rewardBalance > this.maxPointsSpend) {
    //   this.rewardBalance = this.maxPointsSpend;
    //   this.validateRewardAmount();
    // }
  }

  /**
   * Enhanced validation for LRBASE-based reward points (real-time validation)
   */
  validateLRBASERewardAmount(): void {
    if (!this.showRewardsPoints) {
      this.rewardError = '';
      this.canApplyPoints = false;
      return;
    }

    // Recalculate limits first
    this.calculateLRBASERewardLimits();

    const availableBalance = this.userService.customerData['rewardPointBalance'] || 0;

    // If no reward balance entered, clear error
    if (!this.rewardBalance || this.rewardBalance <= 0) {
      this.rewardError = '';
      this.canApplyPoints = false;
      return;
    }

    // Check if points exceed maximum usable points (MPS) - this is the primary constraint
    if (this.rewardBalance > this.maxPointsSpend) {
      this.rewardError = `You can only use up to ${this.maxPointsSpend.toFixed(2)} points for this order`;
      this.canApplyPoints = false;
      return;
    }

    // Check if points exceed available balance
    if (this.rewardBalance > availableBalance) {
      this.rewardError = `Insufficient reward points balance`;
      this.canApplyPoints = false;
      return;
    }

    // Check if points exceed eligible points value (EPV)
    if (this.rewardBalance > this.eligiblePointsValue) {
      this.rewardError = `Amount exceeds eligible amount for this order`;
      this.canApplyPoints = false;
      return;
    }

    // All validations passed
    this.rewardError = '';
    this.canApplyPoints = true;
  }

  /**
   * Handle real-time input validation for reward points
   */
  onRewardPointsInput(): void {
    this.validateLRBASERewardAmount();
  }

  /**
   * Handle input focus - clear placeholder behavior
   */
  onInputFocus(): void {
    // Input is already handled by Angular Material
  }

  /**
   * Handle input blur - validate on blur
   */
  onInputBlur(): void {
    this.validateAndClearOnBlur();
  }

  /**
   * Apply reward points to the order
   */
  applyRewardPoints(): void {
    if (!this.canApplyPoints || this.isApplyingPoints) {
      return;
    }

    this.isApplyingPoints = true;
    
    // Validate one more time before applying
    this.validateLRBASERewardAmount();
    
    if (this.canApplyPoints && this.rewardBalance > 0) {
      this.pointsApplied = this.rewardBalance;
      
      // Recalculate order totals with applied points
      this.recalculateOrderWithPoints();
      
      // Show success message
      this.notificationService.success('Reward points applied successfully!', `Applied ${this.pointsApplied} points to your order.`);
    }
    
    this.isApplyingPoints = false;
  }

  /**
   * Remove applied reward points
   */
  removeRewardPoints(): void {
    this.pointsApplied = 0;
    this.rewardBalance = 0;
    this.canApplyPoints = false;
    this.rewardError = '';
    
    // Recalculate order totals without points
    this.recalculateOrderWithPoints();
    
    this.notificationService.info('Reward points removed', 'Points have been removed from your order.');
  }

  /**
   * Recalculate order totals with applied points
   */
  recalculateOrderWithPoints(): void {
    // Trigger order recalculation to update totals
    this.orderService.calculateOrder();
  }

  /**
   * Get the correct total after applying reward points
   */
  getCorrectedTotal(): number {
    const subtotal = this.orderService.calculateOrderResponse.SubTotal || 0;
    const shipping = this.orderService.calculateOrderResponse.ShippingTotal || 0;
    const tax = this.orderService.calculateOrderResponse.TaxTotal || 0;
    const appliedPoints = this.pointsApplied || 0;
    const discount = this.bounceBackDiscountAmount || 0;
    const discounted = Math.max(0, subtotal - appliedPoints - discount);
    return discounted + shipping + tax;
  }

  /**
   * Validation method for blur event - clears input if invalid
   */
  validateAndClearOnBlur(): void {
    if (!this.showRewardsPoints) {
      this.rewardError = '';
      return;
    }

    // Recalculate limits first
    this.calculateLRBASERewardLimits();

    const availableBalance = this.userService.customerData['rewardPointBalance'] || 0;

    // If no reward balance entered, clear error
    if (!this.rewardBalance || this.rewardBalance <= 0) {
      this.rewardError = '';
      this.pointsApplied = 0;
      return;
    }

    // Check if points exceed maximum usable points (MPS) - this is the primary constraint
    if (this.rewardBalance > this.maxPointsSpend) {
      this.rewardError = `You can only use up to ${this.maxPointsSpend.toFixed(2)} points for this order`;
      this.pointsApplied = 0; // Don't apply invalid points
      this.rewardBalance = 0; // Clear the input box on blur
      return;
    }

    // Check if points exceed available balance
    if (this.rewardBalance > availableBalance) {
      this.rewardError = `Insufficient reward points balance`;
      this.pointsApplied = 0; // Don't apply invalid points
      this.rewardBalance = 0; // Clear the input box on blur
      return;
    }

    // Check if points exceed eligible points value (EPV)
    if (this.rewardBalance > this.eligiblePointsValue) {
      this.rewardError = `Amount exceeds eligible amount for this order`;
      this.pointsApplied = 0; // Don't apply invalid points
      this.rewardBalance = 0; // Clear the input box on blur
      return;
    }

    // All validations passed
    this.rewardError = '';
    this.pointsApplied = this.rewardBalance;
  }

  /**
   * Initialize shipping method if not already set
   */
  initializeShippingMethod(): void {
    if (!this.userService.selectedShippingMethod) {
      // Try to get from available shipping methods first
      if (this.orderService.calculateOrderResponse?.ShippingMethods?.length > 0) {
        this.userService.selectedShippingMethod = this.orderService.calculateOrderResponse.ShippingMethods[0].ShipMethodId;
      } 
      // Fallback to user's shipping methods
      else if (this.userService.shippingMethods?.length > 0) {
        this.userService.selectedShippingMethod = this.userService.shippingMethods[0].ShipMethodId || 
                                               this.userService.shippingMethods[0].ShipMethodID;
      }
      // Final fallback to default shipping method ID
      else {
        this.userService.selectedShippingMethod = this.selectedshipmethod || '1';
      }
    }
  }

  applyCouponCode() {
    if (!this.couponCode || this.couponCode.trim() === '') {
      this.couponError = 'Please enter a coupon code';
      this.couponSuccess = '';
      return;
    }

    // Clear previous messages
    this.couponError = '';
    this.couponSuccess = '';

    // Here you would typically call an API to validate the coupon
    // For now, we'll simulate a coupon validation
    const request = {
      couponCode: this.couponCode.trim(),
      customerId: this.userService.customerData.CustomerId || 0,
      storeId: MARKETPLACESTORE
    };

    // TODO: Replace with actual API call when coupon validation endpoint is available
    // For now, simulate coupon validation
    setTimeout(() => {
      // Simulate API response - replace this with actual API call
      if (this.couponCode.toLowerCase().includes('bounce') || this.couponCode.toLowerCase().includes('back')) {
        this.appliedCoupon = {
          code: this.couponCode,
          discount: 10, // 10% discount
          type: 'percentage'
        };
        this.couponSuccess = `Coupon "${this.couponCode}" applied successfully! 10% discount applied.`;
        this.couponError = '';
        this.couponCode = '';
        
        // Recalculate order with coupon discount
        this.orderService.calculateOrder();
      } else {
        this.couponError = 'Invalid coupon code. Please try again.';
        this.couponSuccess = '';
        this.appliedCoupon = null;
      }
    }, 500);
  }

  removeCouponCode() {
    this.appliedCoupon = null;
    this.couponSuccess = '';
    this.couponError = '';
    this.couponCode = '';
    
    // Recalculate order without coupon
    this.orderService.calculateOrder();
  }
  // BounceBack event handlers
  onBounceBackCouponApplied(coupon: BounceBackCoupon): void {
    this.bounceBackAppliedCoupon = coupon;
    
    // Get the discount amount from the order service response (API calculated)
    this.bounceBackDiscountAmount = this.orderService.calculateOrderResponse.DiscountTotal || 0;
    
    // Store BounceBack data in session storage for order confirmation
    const couponJson = JSON.stringify(coupon);
    sessionStorage.setItem('bounceBackAppliedCoupon', couponJson);
    sessionStorage.setItem('bounceBackDiscountAmount', this.bounceBackDiscountAmount.toString());
    
    // Note: BounceBack coupons are stored in session storage only, not in user service
    // This prevents duplicate coupon codes in the API request
    
    // Update order totals with BounceBack discount
    this.updateOrderWithBounceBackDiscount();
  }

  onBounceBackCouponRemoved(): void {
    this.bounceBackAppliedCoupon = null;
    this.bounceBackDiscountAmount = 0;
    
    // Remove BounceBack coupon from session storage
    sessionStorage.removeItem('bounceBackAppliedCoupon');
    sessionStorage.removeItem('bounceBackDiscountAmount');
    
    // Note: BounceBack coupons are not stored in user service, so no need to remove from there
    
    // Recalculate order without BounceBack discount
    this.orderService.calculateOrder();
  }

  onBounceBackLoadingChanged(loading: boolean): void {
    this.bounceBackLoading = loading;
  }

  private updateOrderWithBounceBackDiscount(): void {
    if (this.bounceBackAppliedCoupon && this.bounceBackDiscountAmount > 0) {
      // The API response already contains the correct calculated values
      // We don't need to manually update the totals since they come from the API
      // The orderService.calculateOrderResponse already has the updated values:
      // - SubTotal: Original subtotal
      // - SubtotalAfterDiscount: Subtotal after bounceback discount
      // - DiscountTotal: The bounceback discount amount
      // - Total: Final total including discount, shipping, and tax
    }
  }

  /**
   * Calculate and return the bounceback discount percentage for display
   */
  getBounceBackDiscountPercentage(): number {
    if (this.orderService.calculateOrderResponse.SubTotal > 0 && this.bounceBackDiscountAmount > 0) {
      const percentage = Math.round((this.bounceBackDiscountAmount / this.orderService.calculateOrderResponse.SubTotal) * 100);
      return percentage;
    }
    return 0;
  }
  
  
    addNewPaymentMethod() {
    // Show the payment method selection dialog that includes e-wallet option
    // This ensures users can choose between credit card and e-wallet when adding a new payment method
    this.showPaymentMethodSelectionDialogForNewPayment();
  }

  // Separate function to show payment method selection dialog for new payments (avoids recursive calls)
  showPaymentMethodSelectionDialogForNewPayment() {
    // Load saved payment methods and show selection dialog
    if (this.userService.customerData.CustomerId) {
      const request = {
        customerId: this.userService.customerData.CustomerId
      };
      
      this.apiService.getCustomerSavedPaymentMethods(request).subscribe(
        (result) => {
          try {
            if (result.Message === "Success" && result.Data && result.Data.length > 0) {
              // Apply saved order from localStorage if available
              this.applySavedPaymentMethodOrder(result.Data);
              
              // Add e-wallet option to the payment methods
              const paymentMethodsWithEwallet = this.addEwalletOption(result.Data);
              
              // Show payment method selection dialog with saved payment methods + e-wallet
              this.showPaymentMethodSelectionDialog(paymentMethodsWithEwallet);
            } else {
              // No saved payment methods, add e-wallet option and show selection dialog
              const paymentMethodsWithEwallet = this.addEwalletOption([]);
              this.showPaymentMethodSelectionDialog(paymentMethodsWithEwallet);
            }
          } catch (ex) {
            console.error('Error loading saved payment methods:', ex);
            // On error, add e-wallet option and show selection dialog
            const paymentMethodsWithEwallet = this.addEwalletOption([]);
            this.showPaymentMethodSelectionDialog(paymentMethodsWithEwallet);
          }
        },
        (error) => {
          console.error('Error loading saved payment methods:', error);
          // On error, add e-wallet option and show selection dialog
          const paymentMethodsWithEwallet = this.addEwalletOption([]);
          this.showPaymentMethodSelectionDialog(paymentMethodsWithEwallet);
        }
      );
    } else {
      // No customer ID, add e-wallet option and show selection dialog
      const paymentMethodsWithEwallet = this.addEwalletOption([]);
      this.showPaymentMethodSelectionDialog(paymentMethodsWithEwallet);
    }
  }

  // Function to open the actual payment method dialog (credit card form)
  openPaymentMethodDialog() {
    // First, get available payment types to determine which payment method to add
    this.paymentService.getPaymentType(true).then(() => {
      if (this.paymentService.PaymentTypeResponse['AllowedMethods'] && 
          this.paymentService.PaymentTypeResponse['AllowedMethods'].length > 0) {
        
        // Get the first available payment method (usually credit card)
        const firstPaymentMethod = this.paymentService.PaymentTypeResponse['AllowedMethods'][0];
        
        // Open the hosted payment dialog to add a new payment method
        this.paymentService.getPaymentData(firstPaymentMethod).then((result) => {
          // Payment method was successfully added
          this.notificationService.success('Success', 'Payment method added successfully');
          
          // Refresh the payment methods list
          this.refreshPaymentMethods();
        }).catch((error) => {
          if (error !== 'Payment method was not added') {
            console.error('Error adding payment method:', error);
            this.notificationService.error('Error', 'Failed to add payment method');
          }
        });
      } else {
        this.notificationService.error('Error', 'No payment methods available from server');
      }
    }).catch((error) => {
      console.error('Payment loading error:', error);
      this.notificationService.error('Error', 'Failed to load payment methods: ' + (error.message || error));
    });
  }

  createMockEwalletOption() {
    // Create a mock e-wallet payment method for testing
    const mockEwalletMethod = {
      MerchantId: EWALLET_MERCHANT_ID,
      Name: 'E-Wallet',
      DisplayName: 'E-Wallet',
      CanGetBalance: true,
      CanSavePayments: true
    };
    
    // Set up mock payment type response
    this.paymentService.PaymentTypeResponse['AllowedMethods'] = [mockEwalletMethod];
    
    // Show the selection dialog
    this.showPaymentMethodSelectionDialog();
  }

  changePaymentMethod() {
    // Load saved payment methods and show selection dialog
    if (this.userService.customerData.CustomerId) {
      const request = {
        customerId: this.userService.customerData.CustomerId
      };
      
      this.apiService.getCustomerSavedPaymentMethods(request).subscribe(
        (result) => {
          try {
            if (result.Message === "Success" && result.Data && result.Data.length > 0) {
              // Apply saved order from localStorage if available
              this.applySavedPaymentMethodOrder(result.Data);
              
              // Add e-wallet option to the payment methods
              const paymentMethodsWithEwallet = this.addEwalletOption(result.Data);
              
              // Show payment method selection dialog with saved payment methods + e-wallet
              this.showPaymentMethodSelectionDialog(paymentMethodsWithEwallet);
            } else {
              // No saved payment methods, add e-wallet option and show selection dialog
              const paymentMethodsWithEwallet = this.addEwalletOption([]);
              this.showPaymentMethodSelectionDialog(paymentMethodsWithEwallet);
            }
          } catch (ex) {
            console.error('Error loading saved payment methods:', ex);
            // On error, add e-wallet option and show selection dialog
            const paymentMethodsWithEwallet = this.addEwalletOption([]);
            this.showPaymentMethodSelectionDialog(paymentMethodsWithEwallet);
          }
        },
        (error) => {
          console.error('Error loading saved payment methods:', error);
          // On error, add e-wallet option and show selection dialog
          const paymentMethodsWithEwallet = this.addEwalletOption([]);
          this.showPaymentMethodSelectionDialog(paymentMethodsWithEwallet);
        }
      );
    } else {
      // No customer ID, add e-wallet option and show selection dialog
      const paymentMethodsWithEwallet = this.addEwalletOption([]);
      this.showPaymentMethodSelectionDialog(paymentMethodsWithEwallet);
    }
  }

  // Add e-wallet option to payment methods if not already present
  addEwalletOption(paymentMethods: any[]): any[] {
    const hasEwallet = paymentMethods.some(pm => pm.MerchantId === EWALLET_MERCHANT_ID || pm.CardType === 'E-Wallet');
    
    // Always add e-wallet option if it's not already present
    if (!hasEwallet) {
      // Add e-wallet option
      const ewalletOption = {
        CardType: 'E-Wallet',
        Ending: 'WALLET',
        Expires: null,
        MerchantId: EWALLET_MERCHANT_ID,
        NameOnAccount: 'Digital Wallet',
        PaymentMethodId: 'ewallet_option',
        PaymentTokenId: 'ewallet_token'
      };
      
      return [...paymentMethods, ewalletOption];
    }
    
    return paymentMethods;
  }

  // Show payment method selection dialog with saved payment methods
  showPaymentMethodSelectionDialog(savedPaymentMethods?: any[]) {
    const dialogRef = this.dialog.open(PaymentMethodSelectionDialogComponent, {
      width: '500px',
      data: {
        allowedMethods: savedPaymentMethods || [],
        isChangeMode: true,
        currentPaymentMethod: this.userService.paymentMethods[0]
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result.action === 'addNew') {
          // User wants to add a new payment method - open the actual payment dialog
          this.openPaymentMethodDialog();
        } else {
          // User selected a payment method
          this.selectPaymentMethod(result);
        }
      }
    });
  }

  // Select a payment method
  selectPaymentMethod(paymentMethod: any) {
    // Clear current payment method
    this.userService.paymentMethods = [];
    
    // Set the selected payment method
    this.userService.paymentMethods = [paymentMethod];
    
    // Set the display name
    if (paymentMethod.CardType === 'E-Wallet' || paymentMethod.Ending === 'WALLET') {
      this.paymentService.selectedPaymentTypeName = 'E-Wallet';
    } else {
      this.paymentService.selectedPaymentTypeName = paymentMethod.CardType + ' ' + paymentMethod.Ending;
    }
    
    // Update localStorage
    localStorage.setItem('userService', JSON.stringify(this.userService));
    
    // Check if e-wallet is selected and show/hide balance accordingly
    if (paymentMethod.CardType === 'E-Wallet' || paymentMethod.MerchantId === EWALLET_MERCHANT_ID) {
      this.isShowEwalletBalance = true;
      
      // Check if this is our placeholder e-wallet option
      if (paymentMethod.PaymentMethodId === 'ewallet_option') {
        // This is our placeholder e-wallet option, fetch the real balance
        if (this.userService.customerData.CustomerId) {
          this.fetchCustomerBalance(EWALLET_MERCHANT_ID, this.userService.customerData.CustomerId);
        } else {
          this.ewalletBalance = 0;
        }
      } else {
        // This is a real e-wallet payment method, get balance using fetchCustomerBalance
        if (this.userService.customerData.CustomerId) {
          this.fetchCustomerBalance(paymentMethod.MerchantId, this.userService.customerData.CustomerId);
        } else {
          this.ewalletBalance = 0;
        }
      }
    } else {
      // Hide e-wallet balance for non-e-wallet payment methods
      this.isShowEwalletBalance = false;
      this.ewalletBalance = 0;
    }
    
    this.notificationService.success('Success', 'Payment method updated successfully');
  }

  clearCurrentPaymentMethod() {
    // Hide e-wallet balance if it was showing
    this.isShowEwalletBalance = false;
    this.ewalletBalance = 0;
    
    // Clear payment methods
    this.userService.paymentMethods = [];
    this.paymentService.selectedPaymentTypeName = '';
    this.paymentService.SelectedPaymentTypes = {};
    
    // Update localStorage
    localStorage.setItem('userService', JSON.stringify(this.userService));
  }

  refreshPaymentMethods() {
    // Refresh the payment methods list
    if (this.paymentService.SelectedPaymentTypes && this.paymentService.SelectedPaymentTypes.CanSavePayments) {
      this.paymentService.getPaymentType().then(() => {
        // Update the userService payment methods with the latest data
        if (this.paymentService.PaymentTypeResponse['SaveMethods'] && 
            this.paymentService.PaymentTypeResponse['SaveMethods'].length > 0) {
          // Map the payment methods to the expected format using the new function
          this.userService.paymentMethods = this.paymentService.PaymentTypeResponse['SaveMethods'].map(method => 
            this.mapPaymentMethodProperties(method)
          );
          
          // Update the selected payment type name
          if (this.userService.paymentMethods.length > 0) {
            const firstMethod = this.userService.paymentMethods[0];
            if (firstMethod.MerchantId === EWALLET_MERCHANT_ID) {
              this.paymentService.selectedPaymentTypeName = 'E-Wallet';
            } else {
            this.paymentService.selectedPaymentTypeName = 
                firstMethod.CardType + ' ' + firstMethod.Ending;
            }
            
            // Check if current payment method is e-wallet and show balance
            if (firstMethod.MerchantId === EWALLET_MERCHANT_ID) {
              this.isShowEwalletBalance = true;
              this.fetchCustomerBalance(firstMethod.MerchantId, this.userService.customerData.CustomerId);
            } else {
              this.isShowEwalletBalance = false;
            }
          }
        }
        
        this.userService.isPaymentChanged = true;
        localStorage.setItem('userService', JSON.stringify(this.userService));
      }).catch((error) => {
        // Error refreshing payment methods
      });
    }
  }

  syncPaymentMethods() {
    // Sync payment methods from payment service if they exist
    if (this.paymentService.PaymentTypeResponse['SaveMethods'] && 
        this.paymentService.PaymentTypeResponse['SaveMethods'].length > 0) {
      // Map the payment methods to the expected format using the new function
      this.userService.paymentMethods = this.paymentService.PaymentTypeResponse['SaveMethods'].map(method => 
        this.mapPaymentMethodProperties(method)
      );
      
      // Update the selected payment type name
      if (this.userService.paymentMethods.length > 0) {
        this.paymentService.selectedPaymentTypeName = 
          this.userService.paymentMethods[0].CardType + ' ' + this.userService.paymentMethods[0].Ending;
      }
      
      localStorage.setItem('userService', JSON.stringify(this.userService));
    }
  }

  // This need to be fixed as we are not getting the saved payment methods on checkout page so I added it but it's response is different from the we need one
  // getCustomerSavedPaymentMethod(){
  //   const request = {
  //     customerId: this.userService.customerData.CustomerId || 0,
  //     // storeId: 4,
  //   };
  //   this.apiService.getCustomerSavedPaymentMethods(request).subscribe(
  //     (result) => {
  //       try {
  //         if (result.Message === "Success") {
  //           if (result.Data.length == 0) {
  //             this.setDefaultPayment();
  //           }
  //           if (result.Data.length > 0) {
  //             result.Data.forEach((item, i) => {
  //               this.userService.paymentMethods[i].CardType = item.CardType,
  //               this.userService.paymentMethods[i].Last4 = item.Ending,
  //               this.userService.paymentMethods[i].ExpireMonth = this.persistentService.retailData.SelectedAutoshipPayment.ExpireMonth,
  //               this.userService.paymentMethods[i].ExpireYear = this.persistentService.retailData.SelectedAutoshipPayment.ExpireYear,
  //               this.userService.paymentMethods[i].Token = item.PaymentMethodID,
  //               this.userService.paymentMethods[i].BillingAddress = this.persistentService.retailData.SelectedAutoshipPayment.BillingAddress,
  //               this.userService.paymentMethods[i].BillingAddress2 = this.persistentService.retailData.SelectedAutoshipPayment.BillingAddress2,
  //               this.userService.paymentMethods[i].BillingCity = this.persistentService.retailData.SelectedAutoshipPayment.BillingCity,
  //               this.userService.paymentMethods[i].BillingCountry = this.persistentService.retailData.SelectedAutoshipPayment.BillingCountry,
  //               this.userService.paymentMethods[i].BillingState = this.persistentService.retailData.SelectedAutoshipPayment.BillingState,
  //               this.userService.paymentMethods[i].BillingZip = this.persistentService.retailData.SelectedAutoshipPayment.BillingZip;
  //             });
  //             // this.userService.paymentMethods = result.Data;            
  //             this.paymentService.selectedPaymentTypeName = this.userService.paymentMethods[0].CardType + ' ' + this.userService.paymentMethods[0].Last4;
  //           }
  //           localStorage.setItem('userService', JSON.stringify(this.userService));
  //         } else {
  //           this.notificationService.error("error_", result.Message);
  //         }
  //       } catch (ex) {
  //         this.notificationService.error(
  //           "error_",
  //           "error_occured_try_again",
  //         );
  //       }
  //     },
  //     (error) => {
  //     },
  //     () => {},
  //   );
  // }
  removeOrderItem(item: any) {
    try {
      this.cart1Service.removeFromCart(item, false, false, true);
      
      // Force refresh the order calculation after removal
      setTimeout(() => {
        if (this.itemsService.selectedOrderItems.length > 0) {
          this.orderService.calculateOrder().then(() => {
            // Order calculation refreshed after item removal
            // Recalculate LRBASE limits if in rewards store
            if (this.showRewardsPoints) {
              this.calculateLRBASERewardLimits();
              this.validateLRBASERewardAmount();
            }
          });
        } else {
          // Clear order data if no items remain
          this.orderService.calculateOrderResponse = {};
          // Reset LRBASE calculations
          if (this.showRewardsPoints) {
            this.maxPointsSpend = 0;
            this.eligiblePointsValue = 0;
            this.lrbaseTotals = 0;
            this.rewardBalance = 0;
            this.rewardError = '';
          }
        }
      }, 100);
    } catch (error) {
      console.error('Error removing order item:', error);
    }
  }

  removeAutoshipItem(item: any) {
    try {
      this.cart1Service.removeFromCart(item, true, false, true);
      
      // Force refresh the autoship calculation after removal
      setTimeout(() => {
        if (this.itemsService.selectedAutoOrderItems.length > 0) {
          this.orderService.calculateAutoOrder().then(() => {
            // Autoship calculation refreshed after item removal
          });
        } else {
          // Clear autoship data if no items remain
          this.orderService.calculateAutoOrderResponse = {};
        }
      }, 100);
    } catch (error) {
      console.error('Error removing autoship item:', error);
    }
  }

  private clearStaleOrderData() {
    // Clear order calculation data if no order items exist
    if (this.itemsService.selectedOrderItems.length === 0 && this.itemsService.selectedPacks.length === 0) {
      this.orderService.calculateOrderResponse = {};
    }

    // Clear BounceBack coupon data on page reload to prevent API/UI mismatch
    this.clearBounceBackDataOnReload();
  }

  /**
   * Clear BounceBack coupon data on page reload to prevent API errors
   * This ensures the UI and API are in sync when the page is refreshed
   */
  private clearBounceBackDataOnReload(): void {
    try {
      // Clear BounceBack coupon from session storage
      sessionStorage.removeItem('bounceBackAppliedCoupon');
      sessionStorage.removeItem('bounceBackDiscountAmount');
      sessionStorage.removeItem('bouncebackOrderTracking');
      
      // Reset component state
      this.bounceBackAppliedCoupon = null;
      this.bounceBackDiscountAmount = 0;
      
      // Remove any BounceBack coupons from user service to prevent API inclusion
      if (this.userService.couponInfo.Allcoupons) {
        this.userService.couponInfo.Allcoupons = this.userService.couponInfo.Allcoupons.filter(
          code => !this.bouncebackService.isBounceBackCoupon(code)
        );
      }
      
    } catch (error) {
      console.warn('[BounceBack] Error clearing coupon data on reload:', error);
    }
  }

  // Get the correct total for display
  getDisplayTotal(): number {
    // If there are order items, use order total
    if (this.itemsService.selectedOrderItems.length > 0 || this.itemsService.selectedPacks.length > 0) {
      return this.getCorrectedTotal();
    }
    
    // If there are only autoship items, use autoship total
    if (this.itemsService.selectedAutoOrderItems.length > 0) {
      return this.orderService.calculateAutoOrderResponse.Total || 0;
    }
    
    return 0;
  }

  // Get the correct item count for display
  getDisplayItemCount(): number {
    let count = 0;
    count += this.itemsService.selectedOrderItems.length;
    count += this.itemsService.selectedPacks.length;
    count += this.itemsService.selectedAutoOrderItems.length;
    return count;
  }

  fetchCustomerBalance(merchantId: number, customerId: string) {
    this.apiService.fetchCustomerBalance(merchantId, customerId).subscribe((result) => {
      if (result && Number(result.Status) === 0) {
        this.ewalletBalance = result.Data || 0;
      } else {
        console.error('Customer balance API error:', result?.Message);
        this.notificationService.error("Error", result?.Message || "Failed to fetch e-wallet balance");
        // Set a default balance for testing
        this.ewalletBalance = 100.00;
      }
    }, error => {
      console.error('Customer balance API call failed:', error);
      this.notificationService.error("Error", "Unable to connect to e-wallet service");
      // Set a default balance for testing
      this.ewalletBalance = 100.00;
    });
  }

  // Map payment method properties to ensure all required fields are present
  mapPaymentMethodProperties(paymentMethod: any): any {
    // Helper function to safely extract month and year from Expires date
    const extractMonthYearFromExpires = (expires: any): { month: number, year: number } => {
      if (!expires) return { month: 0, year: 0 };
      
      try {
        // If expires is already a Date object
        if (expires instanceof Date) {
          return { 
            month: expires.getMonth() + 1, 
            year: expires.getFullYear() 
          };
        }
        
        // If expires is a string, try to parse it
        if (typeof expires === 'string') {
          const date = new Date(expires);
          // Check if the date is valid
          if (!isNaN(date.getTime())) {
            return { 
              month: date.getMonth() + 1, 
              year: date.getFullYear() 
            };
          }
        }
        
        // If expires is a timestamp or other format, try direct Date constructor
        const date = new Date(expires);
        if (!isNaN(date.getTime())) {
          return { 
            month: date.getMonth() + 1, 
            year: date.getFullYear() 
          };
        }
      } catch (error) {
        console.error('Error parsing expiration date:', error, expires);
      }
      
      return { month: 0, year: 0 };
    };

    const { month, year } = extractMonthYearFromExpires(paymentMethod.Expires);
    
    return {
      CardType: paymentMethod.CardType || paymentMethod.Name || paymentMethod.CreditCardTypeDescription || 'Credit Card',
      Ending: paymentMethod.Ending || paymentMethod.Last4 || paymentMethod.CreditCardNumberDisplay || '',
      Expires: paymentMethod.Expires || (paymentMethod.ExpireMonth && paymentMethod.ExpireYear ? 
        new Date(paymentMethod.ExpireYear, paymentMethod.ExpireMonth - 1) : null),
      ExpireMonth: paymentMethod.ExpireMonth || month,
      ExpireYear: paymentMethod.ExpireYear || year,
      Token: paymentMethod.PaymentMethodId || paymentMethod.Token || paymentMethod.token || '',
      token: paymentMethod.PaymentMethodId || paymentMethod.Token || paymentMethod.token || '',
      MerchantId: paymentMethod.MerchantId,
      NameOnAccount: paymentMethod.NameOnAccount || paymentMethod.Name || paymentMethod.CardholderName || '',
      PaymentMethodId: paymentMethod.PaymentMethodId,
      Last4: paymentMethod.Ending || paymentMethod.Last4 || paymentMethod.CreditCardNumberDisplay || '',
      // Keep all original properties
      ...paymentMethod
    };
  }

  // Get customer reward points
  getCustomerRewardPoints(customerId: number) {
    this.apiService.GetCustomerRewardPoints(customerId)
      .subscribe((result: any) => {
        const { Data } = result;
        if (typeof Data == "number") {
          this.userService.customerData['rewardPointBalance'] = Data;
        }
      });
  }
  /**
   * BounceBack: Log autoship completion for backend tracking
   */
  private logAutoshipCompletion(autoOrder: any): void {
    try {
      const customerId = this.userService.customerData.CustomerId;
      const autoshipOrderId = autoOrder.AutoOrderId || autoOrder.OrderId;
      const orderTotal = autoOrder.Total || 0;

      if (customerId && autoshipOrderId && orderTotal > 0) {
        // Log autoship completion for backend automation system
        this.bouncebackUtils.logBounceBackTransaction('reward_earned', {
          action: 'autoship_completed',
          autoshipOrderId,
          customerId,
          orderTotal,
          note: 'Reward crediting handled by backend automation system'
        }, customerId);


      }
    } catch (error) {
      console.error('Error in logAutoshipCompletion:', error);
    }
  }

  /**
   * BounceBack: Log order completion if bounceback coupon was used
   */
  private logOrderCompletion(order: any): void {
    try {
      const customerId = this.userService.customerData.CustomerId;
      const orderId = order.OrderId;
      const orderTotal = order.Total || 0;
      const couponLevel = this.appliedCoupon?.discount || 0;

      if (customerId && orderId && couponLevel > 0) {
        // Get order items for BBC bonus calculation
        const orderItems = [...this.itemsService.selectedOrderItems, ...this.itemsService.selectedPacks];
        
        // Create tracking data for commission calculations
        const trackingData = this.bouncebackService.createOrderTrackingData(
          orderId, 
          customerId, 
          couponLevel, 
          orderItems, 
          orderTotal
        );

        // Store tracking data for backend processing
        sessionStorage.setItem('bouncebackOrderTracking', JSON.stringify(trackingData));

        // Log order completion
        this.bouncebackUtils.logBounceBackTransaction('reward_used', {
          action: 'order_completed_with_bounceback',
          ...trackingData
        }, customerId);


      }
    } catch (error) {
      console.error('Error in logOrderCompletion:', error);
    }
  }

  // Format expiration date correctly using UTC to avoid timezone issues
  formatExpirationDate(expires: any): string {
    if (!expires) return '';
    
    try {
      const date = new Date(expires);
      if (!isNaN(date.getTime())) {
        // Use UTC methods to avoid timezone conversion issues
        const month = date.getUTCMonth() + 1;
        const year = date.getUTCFullYear();
        return `${month.toString().padStart(2, '0')}/${year}`;
      }
    } catch (error) {
      console.error('Error formatting expiration date:', error);
    }
    
    return '';
  }
}
